import { useState } from "react";

// ── MOCK DATA ─────────────────────────────────────────────────────────────────
const ADMISSION = {
  id: 1, admission_no: "IPD20260001", status: "Admitted",
  admission_type: "Planned", admission_date: "2026-04-01", admission_time: "09:30:00",
  expected_discharge_date: "2026-04-07", actual_discharge_date: null,
  diagnosis: "Fever and dehydration — moderate grade pyrexia with signs of dehydration",
  source: "Admin", notes: "Patient cooperative and responsive",
  patient_name: "Nikhil Gornod", patient_phone: "+91 98765 43210", patient_image: null,
  doctor_name: "Dr. Priya Mehta", doctor_image: null, specialization: "General Physician",
  ward_title: "General Ward", bed_number: "G-102", clinic_title: "City Health Clinic",
};

const DOCTORS = [
  { id: 1, doctor_name: "Dr. Priya Mehta",   role: "Attending",    specialization: "General Physician" },
  { id: 2, doctor_name: "Dr. Ravi Kumar",    role: "Specialist",   specialization: "Cardiologist" },
  { id: 3, doctor_name: "Dr. Anjali Singh",  role: "Consultant",   specialization: "Endocrinologist" },
];

const VITALS = [
  { id: 3, recorded_at: "2026-04-02 09:00", bp_systolic: 116, bp_diastolic: 76, pulse: 70, temperature: 97.8, temperature_unit: "C", spo2: 98.9, respiratory_rate: 17, blood_glucose: 105, blood_glucose_type: "Post Meal", recorded_by_name: "Nurse Priya", notes: "Improving" },
  { id: 2, recorded_at: "2026-04-01 21:00", bp_systolic: 118, bp_diastolic: 78, pulse: 74, temperature: 99.1, temperature_unit: "C", spo2: 97.8, respiratory_rate: 19, blood_glucose: null, blood_glucose_type: null, recorded_by_name: "Nurse Ravi", notes: "Slight fever in evening" },
  { id: 1, recorded_at: "2026-04-01 09:45", bp_systolic: 120, bp_diastolic: 80, pulse: 72, temperature: 98.6, temperature_unit: "C", spo2: 98.5, respiratory_rate: 18, blood_glucose: 110, blood_glucose_type: "Fasting", recorded_by_name: "Nurse Priya", notes: null },
];

const ROUNDS = [
  { id: 3, round_date: "2026-04-03", round_time: "10:15", doctor_name: "Dr. Priya Mehta", patient_condition: "Stable", complaints: "No major complaints", examination: "Temp 36.8°C, BP 114/74, patient alert", instructions: "Discontinue IV, oral medications only, plan discharge", prescription_changed: 1, next_round_date: null, notes: "Plan discharge tomorrow if stable" },
  { id: 2, round_date: "2026-04-02", round_time: "09:30", doctor_name: "Dr. Priya Mehta", patient_condition: "Improving", complaints: "Mild headache, fever reducing", examination: "Temp 37.2°C, BP 116/76, hydration improved", instructions: "Continue fluids, switch to oral paracetamol", prescription_changed: 1, next_round_date: "2026-04-03", notes: null },
  { id: 1, round_date: "2026-04-01", round_time: "10:00", doctor_name: "Dr. Aakash Yadav", patient_condition: "Under Observation", complaints: "High fever and body ache", examination: "Temp 38.5°C, BP 120/80, mild dehydration", instructions: "Start IV fluids, monitor temp every 4 hrs", prescription_changed: 0, next_round_date: "2026-04-02", notes: null },
];

const NOTES = [
  { id: 4, note_date: "2026-04-02", note_time: "08:30", shift: "Morning", patient_condition: "Improving", note: "Patient awake. Fever subsided. Taking oral fluids well. Appetite improving steadily.", recorded_by_name: "Nurse Priya Sharma" },
  { id: 3, note_date: "2026-04-01", note_time: "23:00", shift: "Night",   patient_condition: "Stable",            note: "Patient sleeping. Vitals stable. No complaints. IV drip running at prescribed rate.", recorded_by_name: "Nurse Ravi Kumar" },
  { id: 2, note_date: "2026-04-01", note_time: "20:00", shift: "Evening", patient_condition: "Stable",            note: "Fever slightly reduced. Patient had dinner. Complaining of mild headache. Paracetamol administered.", recorded_by_name: "Nurse Anjali" },
  { id: 1, note_date: "2026-04-01", note_time: "09:00", shift: "Morning", patient_condition: "Under Observation", note: "Patient admitted with fever. IV line set up. Started fluids. Patient cooperative and responsive.", recorded_by_name: "Nurse Priya Sharma" },
];

const DIETS = [
  { id: 3, diet_type_title: "Normal Diet",  diet_category: "Medical", meal_frequency: "3 Meals", calories_target: 1800, allergies: null,  special_instructions: "Back to normal diet on recovery", valid_from: "2026-04-03", valid_to: null,         active: 1, assigned_by_name: "Dr. Priya Mehta" },
  { id: 2, diet_type_title: "Soft Diet",    diet_category: "Medical", meal_frequency: "5 Meals", calories_target: 1500, allergies: null,  special_instructions: "Soft diet from day 2", valid_from: "2026-04-02", valid_to: "2026-04-02",  active: 0, assigned_by_name: "Dr. Priya Mehta" },
  { id: 1, diet_type_title: "Liquid Diet",  diet_category: "Medical", meal_frequency: "3 Meals", calories_target: 1200, allergies: null,  special_instructions: "Clear liquids only on day 1", valid_from: "2026-04-01", valid_to: "2026-04-01", active: 0, assigned_by_name: "Dr. Aakash Yadav" },
];

const DOCTOR_CHANGES = [
  { id: 1, old_doctor_name: "Dr. Aakash Yadav", new_doctor_name: "Dr. Priya Mehta", reason: "Dr. Aakash on annual leave", changed_at: "2026-04-03 14:00:00", changed_by_name: "Admin User", notes: null },
];

const PATIENT_FILES = [
  { id:43, file_name:"Chest X-Ray Report",          file:"patient_file/xray.pdf",       file_type:"pdf",   reference_type:"radiology_order_item", reference_id:1,    uploaded_by_name:"Dr. Radha Sharma", created_at:"2026-04-01 11:30:00" },
  { id:44, file_name:"Appendectomy Operation Notes", file:"patient_file/opnotes.pdf",    file_type:"pdf",   reference_type:"procedure_order",       reference_id:1,    uploaded_by_name:"Dr. Ravi Kumar",   created_at:"2026-04-11 10:45:00" },
  { id:45, file_name:"USG Abdomen Report",           file:"patient_file/usg.pdf",        file_type:"pdf",   reference_type:"radiology_order_item", reference_id:2,    uploaded_by_name:"Dr. Radha Sharma", created_at:"2026-04-01 11:45:00" },
  { id:46, file_name:"Consent Form",                 file:"patient_file/consent.pdf",    file_type:"pdf",   reference_type:"ipd_admission",        reference_id:1,    uploaded_by_name:"Admin User",       created_at:"2026-04-01 09:00:00" },
  { id:47, file_name:"Insurance Document",           file:"patient_file/insurance.pdf",  file_type:"doc",   reference_type:null,                   reference_id:null, uploaded_by_name:"Admin User",       created_at:"2026-04-01 08:30:00" },
];

const INIT_DISCHARGE_SUMMARY = {
  id: null,
  final_diagnosis: "",
  discharge_condition: "Improved",
  history_and_presentation: "",
  investigations_summary: "",
  treatment_given: "",
  summary: "",
  discharge_medicines: "",
  dietary_advice: "",
  activity_restrictions: "",
  wound_care: "",
  follow_up_required: 0,
  follow_up_date: "",
  follow_up_notes: "",
  prepared_by_name: "",
  signed_by_name: null,
  signed_at: null,
  notes: "",
};

const INIT_CHARGES = [
  { id:1,  charge_type:"Bed",         description:"G-102 Bed Charges — 5 Days",        quantity:5,   unit_price:500,   total_amount:2500,  charge_date:"2026-04-01", reference_type:"ipd_bed",              reference_id:1, active:1, added_by_name:"Admin User" },
  { id:2,  charge_type:"Radiology",   description:"Chest X-Ray (PA View)",              quantity:1,   unit_price:300,   total_amount:300,   charge_date:"2026-04-01", reference_type:"radiology_order_item", reference_id:1, active:1, added_by_name:"Dr. Priya Mehta" },
  { id:3,  charge_type:"Radiology",   description:"USG Abdomen & Pelvis",               quantity:1,   unit_price:800,   total_amount:800,   charge_date:"2026-04-01", reference_type:"radiology_order_item", reference_id:2, active:1, added_by_name:"Dr. Priya Mehta" },
  { id:4,  charge_type:"Procedure",   description:"Laparoscopic Appendectomy",          quantity:1,   unit_price:25000, total_amount:25000, charge_date:"2026-04-05", reference_type:"procedure_order",      reference_id:1, active:1, added_by_name:"Dr. Ravi Kumar" },
  { id:5,  charge_type:"Medicine",    description:"Paracetamol 500mg — 500mg BD",       quantity:5,   unit_price:5,     total_amount:25,    charge_date:"2026-04-01", reference_type:"ipd_prescription",     reference_id:1, active:1, added_by_name:"Dr. Priya Mehta" },
  { id:6,  charge_type:"Consultation",description:"Doctor Consultation — 3 Visits",    quantity:3,   unit_price:500,   total_amount:1500,  charge_date:"2026-04-02", reference_type:null,                   reference_id:null, active:1, added_by_name:"Admin User" },
  { id:7,  charge_type:"Nursing",     description:"Post-Operative Nursing Care",         quantity:1,   unit_price:2000,  total_amount:2000,  charge_date:"2026-04-05", reference_type:null,                   reference_id:null, active:1, added_by_name:"Admin User" },
  { id:8,  charge_type:"Radiology",   description:"CT Scan Abdomen + Pelvis",            quantity:1,   unit_price:5000,  total_amount:5000,  charge_date:"2026-04-03", reference_type:"radiology_order_item", reference_id:3, active:0, added_by_name:"Dr. Priya Mehta" },
];

const INIT_ADVANCES = [
  { id:1, amount:5000, payment_method:"Cash",   payment_date:"2026-04-01", payment_time:"09:30", transaction_ref:null,          collected_by_name:"Admin User", notes:"Advance at admission" },
  { id:2, amount:5000, payment_method:"Card",   payment_date:"2026-04-04", payment_time:"11:00", transaction_ref:"TXN20260404", collected_by_name:"Admin User", notes:"Pre-surgery advance" },
  { id:3, amount:5000, payment_method:"Online", payment_date:"2026-04-06", payment_time:"16:00", transaction_ref:"UPI20260406", collected_by_name:"Admin User", notes:null },
];

// ── PROCEDURES MOCK DATA ──────────────────────────────────────────────────────
const PROC_STATUS = {
  "Ordered":            { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
  "Scheduled":          { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Pre-Op Preparation": { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "In Progress":        { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "Completed":          { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Post-Op Recovery":   { bg:"rgba(8,145,178,.12)",   color:"#0891b2" },
  "Cancelled":          { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};
const URGENCY = {
  "Emergency": { bg:"rgba(239,68,68,.15)",  color:"#ef4444" },
  "Urgent":    { bg:"rgba(245,158,11,.15)", color:"#f59e0b" },
  "Elective":  { bg:"rgba(16,185,129,.12)", color:"#10b981" },
};
const PROC_ICON = {
  "Surgery":"🔪","Minor Procedure":"🩹","Endoscopy":"🔭",
  "Biopsy":"🧫","Cardiac Procedure":"❤️","Orthopedic Procedure":"🦴",
  "Obstetric Procedure":"🤱","Other":"📋",
};

const INIT_PROCEDURE_ORDERS = [
  { id:1, name:"Laparoscopic Appendectomy", type:"Surgery", urgency:"Urgent", charges:25000, anesthesia:"General", surgeon:"Dr. Ravi Kumar", anesthesiologist:"Dr. Anjali Singh", ot_number:"OT-1", scheduled_date:"2026-04-05", scheduled_time:"09:00", notes:"Pre-op bloods done", status:"Completed", end_date:"2026-04-05", end_time:"11:30", duration:150, complications:"None", operative_notes:"Procedure completed without incident. Appendix removed laparoscopically.", complication_details:null, post_op_instructions:"NPO 6 hrs, clear fluids from evening", follow_up_required:1, cancel_reason:null },
  { id:2, name:"Upper GI Endoscopy (OGD)",  type:"Endoscopy", urgency:"Elective", charges:5000, anesthesia:"Sedation", surgeon:"Dr. Priya Mehta", anesthesiologist:null, ot_number:"Endo-1", scheduled_date:"2026-04-07", scheduled_time:"10:30", notes:"Consent obtained", status:"Scheduled", end_date:null, end_time:null, duration:null, complications:null, operative_notes:null, complication_details:null, post_op_instructions:null, follow_up_required:0, cancel_reason:null },
  { id:3, name:"Central Line Insertion",    type:"Minor Procedure", urgency:"Emergency", charges:3500, anesthesia:"Local", surgeon:"Dr. Ravi Kumar", anesthesiologist:null, ot_number:"ICU-2", scheduled_date:"2026-04-02", scheduled_time:"14:00", notes:null, status:"Ordered", end_date:null, end_time:null, duration:null, complications:null, operative_notes:null, complication_details:null, post_op_instructions:null, follow_up_required:0, cancel_reason:null },
];

// ── TREATMENT MOCK DATA ───────────────────────────────────────────────────────
const PRESCRIPTIONS = [
  {
    id: 2, prescribed_date: "2026-04-02", prescribed_time: "09:45", prescribed_by_name: "Dr. Priya Mehta",
    notes: "Updated — switched to oral",
    medicines: [
      { id: 4, medicine_title: "Paracetamol", medicine_type: "Tablet", medicine_unit: "mg", dosage: "500mg", route: "Oral", frequency: "Thrice Daily", duration_days: 3, start_date: "2026-04-02", end_date: "2026-04-04", instructions: "After meals with water", active: 1, stop_reason: null },
      { id: 5, medicine_title: "Cetirizine",  medicine_type: "Tablet", medicine_unit: "mg", dosage: "10mg",  route: "Oral", frequency: "Once Daily",   duration_days: 5, start_date: "2026-04-02", end_date: "2026-04-06", instructions: "After meals",           active: 1, stop_reason: null },
    ]
  },
  {
    id: 1, prescribed_date: "2026-04-01", prescribed_time: "10:30", prescribed_by_name: "Dr. Aakash Yadav",
    notes: "Initial prescription on admission",
    medicines: [
      { id: 1, medicine_title: "Paracetamol", medicine_type: "Tablet", medicine_unit: "mg", dosage: "1000mg", route: "IV",   frequency: "Every 6 Hours", duration_days: 5, start_date: "2026-04-01", end_date: null,         instructions: "Dilute in 100ml NS", active: 0, stop_reason: "Switched to oral on day 2" },
      { id: 2, medicine_title: "Omeprazole",  medicine_type: "Capsule",medicine_unit: "mg", dosage: "20mg",   route: "Oral", frequency: "Twice Daily",   duration_days: 5, start_date: "2026-04-01", end_date: "2026-04-05", instructions: "Before meals",       active: 1, stop_reason: null },
    ]
  },
];

const LAB_ORDERS = [
  {
    id: 1,
    order_date: "2026-04-01", order_time: "10:00",
    ordered_by_name: "Dr. Priya Mehta",
    lab_title: "WellScan Diagnostic Services",
    priority: "Routine",
    clinical_notes: "Fever — evaluate infection and anaemia",
    notes: null,
    items: [
      { id:1, test_title:"Complete Blood Count (CBC)",            amount:250, status:"Completed",
        result_text:"WBC: 11.2 K/µL (High)\nRBC: 4.5 M/µL (Normal)\nHaemoglobin: 13.2 g/dL (Normal)\nPlatelets: 220 K/µL (Normal)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30", notes:null },
      { id:2, test_title:"Erythrocyte Sedimentation Rate (ESR)", amount:150, status:"Completed",
        result_text:"ESR: 45 mm/hr (High — elevated, consistent with infection)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30", notes:null },
      { id:3, test_title:"Liver Function Test (LFT)",            amount:400, status:"Completed",
        result_text:"ALT: 38 U/L (Normal)\nAST: 42 U/L (Normal)\nALP: 95 U/L (Normal)\nBilirubin: 1.2 mg/dL (Normal)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30", notes:null },
    ]
  },
  {
    id: 2,
    order_date: "2026-04-03", order_time: "09:00",
    ordered_by_name: "Dr. Ravi Kumar",
    lab_title: "WellScan Diagnostic Services",
    priority: "Urgent",
    clinical_notes: "Monitoring — day 3 follow-up bloods",
    notes: "Repeat CBC + RFT",
    items: [
      { id:4, test_title:"Complete Blood Count (CBC)", amount:250, status:"Processing",
        result_text:null, result_date:null, sample_collected_at:"2026-04-03 09:30", notes:null },
      { id:5, test_title:"Renal Function Test (RFT)",  amount:350, status:"Sample Collected",
        result_text:null, result_date:null, sample_collected_at:"2026-04-03 09:30", notes:null },
    ]
  },
  {
    id: 3,
    order_date: "2026-04-04", order_time: "08:30",
    ordered_by_name: "Dr. Priya Mehta",
    lab_title: "WellScan Diagnostic Services",
    priority: "STAT",
    clinical_notes: "Pre-operative workup — surgery at 9am",
    notes: null,
    items: [
      { id:6, test_title:"Complete Blood Count (CBC)",  amount:250, status:"Completed",
        result_text:"WBC: 14.8 K/µL (High)\nRBC: 4.2 M/µL (Normal)\nHaemoglobin: 12.8 g/dL (Low)\nPlatelets: 185 K/µL (Normal)",
        result_date:"2026-04-04", sample_collected_at:"2026-04-04 08:45", notes:"Pre-op urgent CBC" },
      { id:7, test_title:"Blood Sugar Fasting (BSF)",   amount:80,  status:"Completed",
        result_text:"Fasting Blood Sugar: 94 mg/dL (Normal)",
        result_date:"2026-04-04", sample_collected_at:"2026-04-04 08:45", notes:null },
      { id:8, test_title:"Renal Function Test (RFT)",   amount:350, status:"Ordered",
        result_text:null, result_date:null, sample_collected_at:null, notes:"Await sample — patient NPO" },
    ]
  },
];

const RADIOLOGY_ORDERS = [
  {
    id: 1, order_date: "2026-04-01", order_time: "10:00", ordered_by_name: "Dr. Priya Mehta", source: "IPD", notes: null,
    items: [
      { id: 1, test_title: "Chest X-Ray (PA View)",  test_sub_title: "CXR PA",    test_modality: "X-Ray",   amount: 300,  clinical_indication: "Fever — rule out pneumonia",           status: "Completed",  scheduled_date: "2026-04-01", report: "No active consolidation. Heart size normal. Lung fields clear bilaterally.", report_date: "2026-04-01", reported_by_name: "Dr. Radha Sharma", notes: null },
      { id: 2, test_title: "USG Abdomen & Pelvis",   test_sub_title: "Abdo USG",  test_modality: "USG",     amount: 800,  clinical_indication: "Abdominal pain — evaluate liver and GB", status: "Completed",  scheduled_date: "2026-04-01", report: "Liver mildly enlarged. Gallbladder normal. Kidneys normal in size.", report_date: "2026-04-01", reported_by_name: "Dr. Radha Sharma", notes: null },
    ]
  },
  {
    id: 2, order_date: "2026-04-03", order_time: "09:30", ordered_by_name: "Dr. Ravi Kumar", source: "IPD", notes: "Pre-operative assessment",
    items: [
      { id: 3, test_title: "Chest X-Ray (PA View)",  test_sub_title: "CXR PA",    test_modality: "X-Ray",   amount: 300,  clinical_indication: "Pre-op chest assessment",              status: "Completed",  scheduled_date: "2026-04-03", report: "No significant findings. Fit for surgery.", report_date: "2026-04-03", reported_by_name: "Dr. Radha Sharma", notes: null },
      { id: 4, test_title: "CT Scan Abdomen + Pelvis",test_sub_title:"CT Abdo",   test_modality: "CT Scan", amount: 5000, clinical_indication: "Appendicitis rule out",                status: "Scheduled",  scheduled_date: "2026-04-04", report: null, report_date: null, reported_by_name: null, notes: "Urgent — pre-op needed" },
      { id: 5, test_title: "Echocardiography (2D)", test_sub_title: "2D Echo",    test_modality: "Echocardiography", amount: 2000, clinical_indication: "Cardiac clearance before surgery", status: "Ordered", scheduled_date: null, report: null, report_date: null, reported_by_name: null, notes: null },
    ]
  },
];

// ── HELPERS ───────────────────────────────────────────────────────────────────
const initials = n => (n||"?").split(" ").map(x=>x[0]).join("").slice(0,2).toUpperCase();
const fmtDate  = d => new Date(d).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"});
const COND_COLOR = { "Stable":"#10b981","Improving":"#3b82f6","Under Observation":"#f59e0b","Critical":"#ef4444","Deteriorating":"#dc2626" };
const COND_BG    = { "Stable":"rgba(16,185,129,.12)","Improving":"rgba(59,130,246,.12)","Under Observation":"rgba(245,158,11,.12)","Critical":"rgba(239,68,68,.12)","Deteriorating":"rgba(220,38,38,.12)" };
const SHIFT_COLOR = { Morning:"#f59e0b", Evening:"#6366f1", Night:"#0891b2" };
const SHIFT_ICON  = { Morning:"☀️", Evening:"🌆", Night:"🌙" };

const CONDITION_STYLE = {
  "Recovered":             { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Improved":              { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Stable":                { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
  "Referred":              { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "Against Medical Advice":{ bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Death":                 { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};

const PRIORITY_STYLE = {
  "Routine": { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Urgent":  { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "STAT":    { bg:"rgba(239,68,68,.15)",   color:"#ef4444" },
};

const LAB_STATUS_STYLE = {
  "Ordered":          { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
  "Sample Collected": { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Processing":       { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Completed":        { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Cancelled":        { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};

// ── CSS ───────────────────────────────────────────────────────────────────────
const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{
  --bg:#0A0C12; --bg2:#111318; --bg3:#181B24; --bg4:#1E2130;
  --border:#252836; --border2:#2E3348;
  --text:#EDF0FF; --muted:#6B7A99; --dim:#3D4563;
  --accent:#5E7BFF; --accent2:#8B9FFF;
  --green:#10B981; --red:#EF4444; --amber:#F59E0B; --blue:#3B82F6;
  --teal:#0891B2; --purple:#7C3AED;
}
body{background:var(--bg);color:var(--text);font-family:'IBM Plex Sans',sans-serif;min-height:100vh;}
.page{max-width:1160px;margin:0 auto;padding:28px 20px;}
.back-btn{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--muted);background:none;border:none;cursor:pointer;padding:6px 0;margin-bottom:20px;font-family:'IBM Plex Sans',sans-serif;transition:color .15s;}
.back-btn:hover{color:var(--text);}

/* Header card */
.header-card{background:var(--bg2);border:1px solid var(--border);border-radius:16px;padding:24px 28px;margin-bottom:20px;display:grid;grid-template-columns:1fr auto;gap:24px;}
.patient-row{display:flex;align-items:center;gap:16px;margin-bottom:16px;}
.avatar{width:52px;height:52px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-family:'Playfair Display',serif;font-size:18px;font-weight:600;color:#fff;flex-shrink:0;}
.patient-name{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:var(--text);}
.patient-phone{font-size:12px;color:var(--muted);margin-top:2px;}
.admission-no{font-family:'IBM Plex Mono',monospace;font-size:11px;color:var(--accent2);background:rgba(94,123,255,.1);padding:3px 10px;border-radius:6px;display:inline-block;margin-bottom:12px;}
.meta-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;}
.meta-item{background:var(--bg3);border-radius:10px;padding:10px 14px;}
.meta-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;margin-bottom:3px;}
.meta-value{font-size:13px;font-weight:500;color:var(--text);}
.status-badge{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;}
.status-admitted{background:rgba(16,185,129,.12);color:#10b981;}
.status-discharged{background:rgba(239,68,68,.12);color:#ef4444;}
.days-box{background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.2);border-radius:12px;padding:16px 24px;text-align:center;min-width:100px;}
.days-num{font-family:'Playfair Display',serif;font-size:42px;font-weight:700;color:#10b981;line-height:1;}
.days-label{font-size:11px;color:var(--muted);margin-top:4px;}

/* Doctors row */
.doctors-row{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px;}
.doctor-chip{display:flex;align-items:center;gap:8px;background:var(--bg3);border:1px solid var(--border);border-radius:20px;padding:5px 12px 5px 5px;}
.doc-av{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#fff;}
.doc-name{font-size:12px;font-weight:500;color:var(--text);}
.doc-role{font-size:10px;color:var(--muted);}

/* Tabs */
.tabs{display:flex;gap:2px;background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:4px;margin-bottom:20px;overflow-x:auto;}
.tab{flex:1;min-width:max-content;padding:8px 14px;border-radius:8px;font-size:12px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;display:flex;align-items:center;gap:6px;justify-content:center;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;white-space:nowrap;}
.tab.active{background:var(--accent);color:#fff;}
.tab:hover:not(.active){background:var(--bg3);color:var(--text);}

/* Cards */
.card{background:var(--bg2);border:1px solid var(--border);border-radius:14px;overflow:hidden;margin-bottom:16px;}
.card-header{padding:14px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;}
.card-title{font-family:'Playfair Display',serif;font-size:15px;font-weight:600;display:flex;align-items:center;gap:8px;}
.card-accent{width:3px;height:18px;border-radius:2px;display:inline-block;}
.empty-state{padding:40px 20px;text-align:center;color:var(--muted);font-size:13px;}

/* Vitals */
.vitals-row{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;padding:16px 20px;border-bottom:1px solid var(--border);}
.vitals-row:last-child{border-bottom:none;}
.vital-item{background:var(--bg3);border-radius:10px;padding:10px 12px;}
.vital-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;}
.vital-value{font-family:'IBM Plex Mono',monospace;font-size:16px;font-weight:500;}
.vital-meta{display:flex;align-items:center;justify-content:space-between;padding:10px 20px 4px;border-bottom:1px solid var(--border);}
.vital-meta:last-child{border-bottom:none;}

/* Rounds */
.round-item{padding:16px 20px;border-bottom:1px solid var(--border);}
.round-item:last-child{border-bottom:none;}
.round-header{display:flex;align-items:center;gap:10px;margin-bottom:10px;}
.round-date{font-family:'IBM Plex Mono',monospace;font-size:11px;color:var(--muted);}
.round-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;}
.round-field{background:var(--bg3);border-radius:8px;padding:10px 12px;}
.round-field-label{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.06em;margin-bottom:3px;}
.round-field-value{font-size:12px;color:var(--text);line-height:1.5;}

/* Nursing notes */
.note-item{padding:16px 20px;border-bottom:1px solid var(--border);display:grid;grid-template-columns:auto 1fr;gap:14px;}
.note-item:last-child{border-bottom:none;}
.shift-badge{padding:4px 10px;border-radius:6px;font-size:10px;font-weight:600;text-align:center;min-width:60px;}
.note-text{font-size:13px;color:var(--muted);line-height:1.6;margin-top:4px;}

/* Diet */
.diet-item{padding:14px 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:14px;}
.diet-item:last-child{border-bottom:none;}
.diet-badge{padding:4px 12px;border-radius:20px;font-size:11px;font-weight:600;}
.diet-info{flex:1;}
.diet-name{font-size:14px;font-weight:500;color:var(--text);}
.diet-sub{font-size:12px;color:var(--muted);margin-top:2px;}
.current-tag{font-size:10px;padding:2px 8px;border-radius:10px;background:rgba(16,185,129,.12);color:#10b981;font-weight:600;}
.past-tag{font-size:10px;padding:2px 8px;border-radius:10px;background:var(--bg3);color:var(--muted);font-weight:600;}

/* Doctor changes */
.change-item{padding:16px 20px;border-bottom:1px solid var(--border);display:flex;gap:14px;align-items:flex-start;}
.change-item:last-child{border-bottom:none;}
.change-arrow{display:flex;flex-direction:column;align-items:center;gap:4px;flex-shrink:0;}
.change-from{font-size:12px;color:var(--text);font-weight:500;text-align:center;}
.change-to{font-size:12px;color:var(--green);font-weight:500;text-align:center;}
.arrow-icon{color:var(--accent);font-size:16px;}
.cond-badge{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:12px;font-size:11px;font-weight:600;}
.rx-chip{font-size:10px;padding:2px 7px;border-radius:8px;font-weight:600;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:7px 14px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;border:none;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;}
.btn-primary{background:var(--accent);color:#fff;}
.btn-primary:hover{background:#4A67E8;}
.btn-ghost{background:var(--bg3);color:var(--text);border:1px solid var(--border2);}
.btn-ghost:hover{border-color:var(--accent);color:var(--accent2);}
.divider{height:1px;background:var(--border);margin:4px 0;}
.tag{font-size:10px;padding:2px 7px;border-radius:6px;font-weight:600;}
.files-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:10px;padding:16px 20px;}
.file-card{background:var(--bg3);border:1px solid var(--border);border-radius:10px;padding:12px 14px;display:flex;flex-direction:column;gap:8px;transition:border-color .15s;}
.file-card:hover{border-color:var(--border2);}
.file-icon{width:38px;height:38px;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;}
.file-name{font-size:13px;font-weight:500;color:var(--text);line-height:1.3;}
.file-meta{font-size:10px;color:var(--muted);}
.file-ref{font-size:10px;padding:2px 7px;border-radius:5px;font-weight:600;display:inline-flex;align-items:center;gap:3px;}
.mfull{grid-column:1/-1;}
.toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--bg2);border:1px solid var(--border2);border-radius:10px;padding:10px 20px;display:flex;align-items:center;gap:8px;font-size:13px;color:var(--text);z-index:100;box-shadow:0 4px 24px rgba(0,0,0,.4);}
.modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:50;display:flex;align-items:center;justify-content:center;padding:20px;}
.modal-box{background:var(--bg2);border:1px solid var(--border2);border-radius:16px;padding:28px;width:100%;max-width:580px;max-height:90vh;overflow-y:auto;}
.modal-title{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;}
.modal-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}
.modal-full{grid-column:1/-1;}
.field{display:flex;flex-direction:column;gap:6px;}
.field label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;}
.input{width:100%;padding:9px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);color:var(--text);font-size:13px;font-family:'IBM Plex Sans',sans-serif;outline:none;transition:border-color .15s;}
.input:focus{border-color:var(--accent);}
.select-i{appearance:none;cursor:pointer;}
.textarea{resize:vertical;min-height:70px;}
.modal-actions{display:flex;gap:8px;justify-content:flex-end;margin-top:18px;padding-top:14px;border-top:1px solid var(--border);}
.stab{padding:7px 14px;border-radius:0;font-size:12px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;font-family:'IBM Plex Sans',sans-serif;border-bottom:2px solid transparent;transition:all .15s;}
.stab.active{color:var(--accent2);border-bottom-color:var(--accent);}
.stab:hover:not(.active){color:var(--text);}
.treat-sub-tabs{display:flex;gap:0;padding:0 20px;border-bottom:1px solid var(--border);background:var(--bg3);}
.rx-item{padding:14px 20px;border-bottom:1px solid var(--border);}
.rx-item:last-child{border-bottom:none;}
.medicine-row{display:flex;align-items:center;gap:10px;padding:8px 12px;background:var(--bg3);border-radius:8px;margin-bottom:5px;}
.medicine-row:last-child{margin-bottom:0;}
.med-name{font-size:13px;font-weight:500;min-width:110px;}
.med-chip{padding:2px 7px;border-radius:5px;background:var(--bg4);color:var(--muted);font-size:10px;font-weight:500;}
.stopped{background:rgba(239,68,68,.1);color:#ef4444;}
.active-m{background:rgba(16,185,129,.1);color:#10b981;}
.lab-row{padding:14px 20px;border-bottom:1px solid var(--border);}
.lab-row:last-child{border-bottom:none;}
.stat-pill{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:12px;font-size:11px;font-weight:600;}
.result-box{background:var(--bg3);border-radius:8px;padding:10px 12px;font-size:12px;color:var(--muted);line-height:1.5;margin-top:8px;}
.icon-btn{width:26px;height:26px;border-radius:6px;border:1px solid var(--border2);background:transparent;color:var(--muted);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11px;transition:all .15s;font-family:'IBM Plex Sans',sans-serif;}
.icon-btn:hover{border-color:var(--accent2);color:var(--accent2);}
.icon-btn.del:hover{border-color:#ef4444;color:#ef4444;}
.mod-chip{font-size:10px;padding:2px 8px;border-radius:6px;font-weight:600;}
.billing-grid { display:grid; grid-template-columns:1fr 1fr; gap:16px; margin-bottom:20px; }
.bill-summary-card { background:var(--bg2); border:1px solid var(--border); border-radius:12px; padding:20px; }
.bill-summary-title { font-size:11px; color:var(--muted); text-transform:uppercase; letter-spacing:.07em; margin-bottom:12px; font-weight:600; }
.bill-row { display:flex; justify-content:space-between; align-items:center; padding:7px 0; border-bottom:1px solid var(--border); font-size:12px; }
.bill-row:last-child { border-bottom:none; }
.bill-row-label { color:var(--muted); }
.bill-row-value { font-family:'IBM Plex Mono',monospace; font-weight:600; }
.bill-total-row { display:flex; justify-content:space-between; align-items:center; padding:10px 0 0; font-size:14px; font-weight:700; margin-top:6px; border-top:2px solid var(--border2); }
.charge-row { display:flex; align-items:center; gap:10px; padding:11px 20px; border-bottom:1px solid var(--border); transition:background .1s; }
.charge-row:hover { background:var(--bg3); }
.charge-row.inactive { opacity:.45; }
.charge-type-badge { font-size:10px; padding:2px 8px; border-radius:6px; font-weight:600; flex-shrink:0; }
.advance-row { display:flex; align-items:center; gap:10px; padding:11px 20px; border-bottom:1px solid var(--border); }
.pay-method-badge { font-size:10px; padding:2px 8px; border-radius:6px; font-weight:600; }
.bill-net-payable { background:linear-gradient(135deg,rgba(94,123,255,.15),rgba(139,159,255,.08)); border:1px solid rgba(94,123,255,.3); border-radius:12px; padding:16px 20px; display:flex; justify-content:space-between; align-items:center; margin-top:16px; }
.bill-net-label { font-size:13px; font-weight:600; color:var(--accent2); }
.bill-net-value { font-family:'IBM Plex Mono',monospace; font-size:22px; font-weight:700; color:var(--accent2); }
.btn-sm{padding:4px 10px!important;font-size:11px!important;}
.lab-order-card{background:var(--bg2);border:1px solid var(--border);border-radius:12px;overflow:hidden;margin-bottom:10px;}
.lab-order-head{padding:12px 16px;display:flex;align-items:center;gap:10px;cursor:pointer;transition:background .1s;}
.lab-order-head:hover{background:var(--bg3);}
.lab-item-row{padding:11px 16px 11px 24px;border-top:1px solid var(--border);display:flex;align-items:flex-start;gap:10px;}
.lab-result-box{background:var(--bg3);border-radius:8px;padding:8px 10px;font-size:11px;color:var(--muted);line-height:1.6;margin-top:6px;white-space:pre-line;}
.priority-badge{font-size:10px;padding:2px 8px;border-radius:6px;font-weight:700;}
.discharge-section{background:var(--bg2);border:1px solid var(--border);border-radius:12px;overflow:hidden;margin-bottom:12px;}
.discharge-section-head{padding:12px 16px;background:var(--bg3);display:flex;align-items:center;gap:8px;border-bottom:1px solid var(--border);}
.discharge-section-label{font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.07em;color:var(--muted);}
.discharge-section-body{padding:14px 16px;}
.discharge-field-value{font-size:13px;color:var(--text);line-height:1.7;white-space:pre-line;}
.discharge-empty-field{font-size:12px;color:var(--dim);font-style:italic;}
.condition-badge{font-size:11px;padding:3px 10px;border-radius:20px;font-weight:600;}
.signed-banner{background:rgba(16,185,129,.08);border:1px solid rgba(16,185,129,.2);border-radius:10px;padding:12px 16px;display:flex;align-items:center;gap:10px;margin-bottom:16px;}
.unsigned-banner{background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.2);border-radius:10px;padding:12px 16px;display:flex;align-items:center;gap:10px;margin-bottom:16px;}
`;

// ── COMPONENTS ────────────────────────────────────────────────────────────────
const Av = ({ name, size=36, color="#5E7BFF" }) => (
  <div className="avatar" style={{ width:size, height:size, fontSize:size*.33, background:color }}>
    {initials(name)}
  </div>
);

const CondBadge = ({ c }) => (
  <span className="cond-badge" style={{ background:COND_BG[c]||"var(--bg3)", color:COND_COLOR[c]||"var(--muted)" }}>
    <span style={{ width:5,height:5,borderRadius:"50%",background:COND_COLOR[c]||"var(--muted)",display:"inline-block" }}/>
    {c}
  </span>
);

const COLORS = ["#5E7BFF","#10B981","#F59E0B","#0891B2","#7C3AED","#EF4444"];
const doctorColor = (name) => COLORS[(name||"").charCodeAt(0)%COLORS.length];

// ── TAB PANELS ────────────────────────────────────────────────────────────────
function VitalsPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#10B981" }}/>
          Vitals Tracking
        </div>
        <button className="btn btn-primary">+ Record Vitals</button>
      </div>
      {VITALS.length === 0 ? <div className="empty-state">No vitals recorded yet</div> : VITALS.map((v, i) => (
        <div key={v.id}>
          <div className="vital-meta">
            <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, color:"var(--muted)" }}>{v.recorded_at}</span>
            <span style={{ fontSize:11, color:"var(--muted)" }}>by {v.recorded_by_name}</span>
            {v.notes && <span style={{ fontSize:11, color:"var(--accent2)", fontStyle:"italic" }}>{v.notes}</span>}
          </div>
          <div className="vitals-row">
            {[
              { label:"Blood Pressure", value:`${v.bp_systolic}/${v.bp_diastolic}`, unit:"mmHg", color: v.bp_systolic > 130 ? "#EF4444" : "#10B981" },
              { label:"Pulse",          value:v.pulse,    unit:"bpm",    color:"#F59E0B" },
              { label:"Temperature",    value:`${v.temperature}°${v.temperature_unit}`, unit:"", color: v.temperature > 37.5 ? "#EF4444" : "#10B981" },
              { label:"SpO₂",           value:`${v.spo2}%`, unit:"",   color: v.spo2 < 95 ? "#EF4444" : "#10B981" },
              { label:"Resp. Rate",     value:v.respiratory_rate, unit:"/min", color:"#3B82F6" },
              ...(v.blood_glucose ? [{ label:"Blood Glucose", value:`${v.blood_glucose}`, unit:`mg/dL · ${v.blood_glucose_type}`, color:"#7C3AED" }] : []),
            ].map(item => (
              <div className="vital-item" key={item.label}>
                <div className="vital-label">{item.label}</div>
                <div className="vital-value" style={{ color:item.color }}>{item.value}</div>
                {item.unit && <div style={{ fontSize:10, color:"var(--muted)", marginTop:2 }}>{item.unit}</div>}
              </div>
            ))}
          </div>
          {i < VITALS.length-1 && <div className="divider"/>}
        </div>
      ))}
    </div>
  );
}

function RoundsPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#5E7BFF" }}/>
          Doctor Rounds
        </div>
        <button className="btn btn-primary">+ Add Round</button>
      </div>
      {ROUNDS.map(r => (
        <div className="round-item" key={r.id}>
          <div className="round-header">
            <Av name={r.doctor_name} size={30} color={doctorColor(r.doctor_name)}/>
            <div>
              <div style={{ fontSize:13, fontWeight:500 }}>{r.doctor_name}</div>
              <div className="round-date">{r.round_date} · {r.round_time}</div>
            </div>
            <CondBadge c={r.patient_condition}/>
            {r.prescription_changed === 1 && (
              <span className="rx-chip" style={{ background:"rgba(124,58,237,.15)", color:"#7C3AED" }}>Rx Changed</span>
            )}
            {r.next_round_date && (
              <span className="rx-chip" style={{ background:"rgba(59,130,246,.12)", color:"#3B82F6" }}>Next: {r.next_round_date}</span>
            )}
          </div>
          <div className="round-grid">
            {r.complaints && (
              <div className="round-field">
                <div className="round-field-label">Complaints</div>
                <div className="round-field-value">{r.complaints}</div>
              </div>
            )}
            {r.examination && (
              <div className="round-field">
                <div className="round-field-label">Examination</div>
                <div className="round-field-value">{r.examination}</div>
              </div>
            )}
            {r.instructions && (
              <div className="round-field">
                <div className="round-field-label">Instructions</div>
                <div className="round-field-value">{r.instructions}</div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

function NursingPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#0891B2" }}/>
          Nursing Notes
        </div>
        <button className="btn btn-primary">+ Add Note</button>
      </div>
      {NOTES.map(n => (
        <div className="note-item" key={n.id}>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:4, minWidth:64 }}>
            <div className="shift-badge" style={{ background:`${SHIFT_COLOR[n.shift]}22`, color:SHIFT_COLOR[n.shift] }}>
              {SHIFT_ICON[n.shift]} {n.shift}
            </div>
            <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--muted)" }}>{n.note_time}</div>
            <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--dim)" }}>{n.note_date}</div>
          </div>
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6 }}>
              <span style={{ fontSize:12, fontWeight:500, color:"var(--text)" }}>{n.recorded_by_name}</span>
              <CondBadge c={n.patient_condition}/>
            </div>
            <div className="note-text">{n.note}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

function DietPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#F59E0B" }}/>
          Diet Plan
        </div>
        <button className="btn btn-primary">+ Assign Diet</button>
      </div>
      {DIETS.map(d => (
        <div className="diet-item" key={d.id}>
          <div>
            <div className="diet-badge" style={{ background:`${d.active ? "#10B981" : "#6B7A99"}22`, color: d.active ? "#10B981" : "#6B7A99" }}>
              {d.active ? "Current" : "Past"}
            </div>
          </div>
          <div className="diet-info">
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <div className="diet-name">{d.diet_type_title}</div>
              <span className="tag" style={{ background:"rgba(94,123,255,.12)", color:"var(--accent2)" }}>{d.diet_category}</span>
              <span className="tag" style={{ background:"var(--bg3)", color:"var(--muted)" }}>{d.meal_frequency}</span>
              {d.calories_target && <span className="tag" style={{ background:"rgba(245,158,11,.12)", color:"#F59E0B" }}>{d.calories_target} kcal</span>}
            </div>
            <div className="diet-sub">
              {d.special_instructions && <span>{d.special_instructions}</span>}
              {d.allergies && <span style={{ color:"#EF4444", marginLeft:8 }}>⚠ Allergies: {d.allergies}</span>}
            </div>
            <div style={{ fontSize:11, color:"var(--muted)", marginTop:4 }}>
              {d.valid_from} → {d.valid_to || "Until discharge"} · Assigned by {d.assigned_by_name}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function DoctorChangePanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#7C3AED" }}/>
          Doctor Changes
        </div>
        <button className="btn btn-primary">+ Change Doctor</button>
      </div>
      {DOCTOR_CHANGES.length === 0 ? (
        <div className="empty-state">No doctor changes during this stay</div>
      ) : DOCTOR_CHANGES.map(c => (
        <div className="change-item" key={c.id}>
          <div className="change-arrow">
            <div className="change-from">{c.old_doctor_name.split(" ").slice(-1)[0]}</div>
            <div className="arrow-icon">↓</div>
            <div className="change-to">{c.new_doctor_name.split(" ").slice(-1)[0]}</div>
          </div>
          <div style={{ flex:1 }}>
            <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:6 }}>
              <span style={{ fontSize:13, fontWeight:500 }}>{c.old_doctor_name}</span>
              <span style={{ color:"var(--muted)", fontSize:12 }}>→</span>
              <span style={{ fontSize:13, fontWeight:500, color:"#10B981" }}>{c.new_doctor_name}</span>
            </div>
            <div style={{ fontSize:12, color:"var(--muted)", marginBottom:4 }}>
              <span style={{ color:"var(--text)" }}>Reason:</span> {c.reason}
            </div>
            <div style={{ fontSize:11, color:"var(--dim)" }}>
              Changed by {c.changed_by_name} · {c.changed_at}
            </div>
            {c.notes && <div style={{ fontSize:12, color:"var(--accent2)", fontStyle:"italic", marginTop:4 }}>{c.notes}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}

function TransferPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">
          <span className="card-accent" style={{ background:"#EF4444" }}/>
          Patient Transfer
        </div>
        <button className="btn btn-primary">+ Transfer Patient</button>
      </div>
      <div className="empty-state">
        <div style={{ fontSize:28, marginBottom:8 }}>🚶</div>
        No transfers during this stay
      </div>
    </div>
  );
}

// ── TREATMENT PANEL ───────────────────────────────────────────────────────────
const STATUS_PILL = {
  Completed:  { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  Pending:    { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  Processing: { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  Scheduled:  { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  Cancelled:  { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};
const MODALITY_COLOR = {
  "X-Ray":   { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "USG":     { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "CT Scan": { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "MRI":     { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "PET":     { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};

function Modal({ title, onClose, children }) {
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-title">
          {title}
          <button onClick={onClose} style={{ background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18,lineHeight:1 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function PrescriptionModal({ onClose, editData }) {
  const isEdit = Boolean(editData);
  return (
    <Modal title={isEdit ? "Edit Prescription" : "Add Prescription"} onClose={onClose}>
      <div className="modal-grid">
        <div className="field modal-full">
          <label>Prescribed By</label>
          <select className="input select-i" defaultValue={editData?.prescribed_by_name||""}>
            <option value="">Select doctor</option>
            {DOCTORS.map(d => <option key={d.id} value={d.doctor_name}>{d.doctor_name}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Prescribed Date</label>
          <input className="input" type="date" defaultValue={editData?.prescribed_date||"2026-04-01"}/>
        </div>
        <div className="field">
          <label>Prescribed Time</label>
          <input className="input" type="time" defaultValue={editData?.prescribed_time||""}/>
        </div>
        <div className="field modal-full">
          <label>Notes</label>
          <textarea className="input textarea" defaultValue={editData?.notes||""} placeholder="Prescription notes…"/>
        </div>
      </div>
      <div style={{ fontSize:11, color:"var(--muted)", marginBottom:10, fontWeight:600, textTransform:"uppercase", letterSpacing:".07em" }}>Medicines</div>
      {[{ label:"Medicine", w:"1fr" },{ label:"Dosage", w:"80px" },{ label:"Route", w:"90px" },{ label:"Frequency", w:"120px" },{ label:"Instructions", w:"1fr" }].map((h,i) => null)}
      {(editData?.medicines||[{ medicine_title:"", dosage:"", route:"Oral", frequency:"Once Daily", instructions:"" }]).map((m,i) => (
        <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 70px 90px 120px 1fr 28px", gap:6, marginBottom:6, alignItems:"end" }}>
          <div className="field"><label style={{ fontSize:9 }}>Medicine</label><input className="input" defaultValue={m.medicine_title} placeholder="Medicine name"/></div>
          <div className="field"><label style={{ fontSize:9 }}>Dosage</label><input className="input" defaultValue={m.dosage} placeholder="500mg"/></div>
          <div className="field"><label style={{ fontSize:9 }}>Route</label>
            <select className="input select-i" defaultValue={m.route}>
              {["Oral","IV","IM","SC","Topical","Sublingual","Inhaled","Rectal","Nasal","Other"].map(r => <option key={r}>{r}</option>)}
            </select>
          </div>
          <div className="field"><label style={{ fontSize:9 }}>Frequency</label>
            <select className="input select-i" defaultValue={m.frequency}>
              {["Once Daily","Twice Daily","Thrice Daily","Every 4 Hours","Every 6 Hours","Every 8 Hours","Every 12 Hours","SOS","Stat"].map(f => <option key={f}>{f}</option>)}
            </select>
          </div>
          <div className="field"><label style={{ fontSize:9 }}>Instructions</label><input className="input" defaultValue={m.instructions} placeholder="After meals"/></div>
          <button className="icon-btn del" style={{ marginTop:18 }}>✕</button>
        </div>
      ))}
      <button className="btn btn-ghost" style={{ fontSize:11, marginTop:6 }}>+ Add Medicine</button>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isEdit ? "Update" : "Add"} Prescription</button>
      </div>
    </Modal>
  );
}

function StopMedicineModal({ medicine, onClose }) {
  return (
    <Modal title={`Stop — ${medicine.medicine_title}`} onClose={onClose}>
      <div style={{ background:"rgba(239,68,68,.08)", border:"1px solid rgba(239,68,68,.2)", borderRadius:8, padding:"10px 14px", fontSize:12, color:"#ef4444", marginBottom:16 }}>
        ⚠ This will mark the medicine as stopped and record the reason.
      </div>
      <div className="modal-grid">
        <div className="field modal-full">
          <label>Stop Reason <span style={{ color:"#ef4444" }}>*</span></label>
          <input className="input" placeholder="e.g. Switched to oral, Side effect observed…"/>
        </div>
        <div className="field">
          <label>End Date</label>
          <input className="input" type="date" defaultValue="2026-04-03"/>
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn" style={{ background:"rgba(239,68,68,.15)", color:"#ef4444", border:"1px solid rgba(239,68,68,.3)" }}>Stop Medicine</button>
      </div>
    </Modal>
  );
}

function LabModal({ onClose, editData, isResult }) {
  const isEdit = Boolean(editData);
  return (
    <Modal title={isResult ? `Add Result — ${editData?.test_name}` : isEdit ? "Edit Lab Order" : "Add Lab Order"} onClose={onClose}>
      {!isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Test Name <span style={{ color:"#ef4444" }}>*</span></label>
            <input className="input" defaultValue={editData?.test_name||""} placeholder="e.g. Complete Blood Count (CBC)"/>
          </div>
          <div className="field">
            <label>Ordered By</label>
            <select className="input select-i"><option>Dr. Priya Mehta</option>{DOCTORS.map(d=><option key={d.id}>{d.doctor_name}</option>)}</select>
          </div>
          <div className="field">
            <label>Order Date</label>
            <input className="input" type="date" defaultValue={editData?.order_date||"2026-04-01"}/>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="input select-i" defaultValue={editData?.status||"Pending"}>
              {["Pending","Processing","Completed","Cancelled"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" defaultValue={editData?.notes||""} placeholder="Additional notes…"/>
          </div>
        </div>
      )}
      {isResult && (
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Result Value <span style={{ color:"#ef4444" }}>*</span></label>
            <textarea className="input textarea" defaultValue={editData?.result_value||""} placeholder="Enter lab result values…" style={{ minHeight:100 }}/>
          </div>
          <div className="field">
            <label>Result Date</label>
            <input className="input" type="date" defaultValue="2026-04-01"/>
          </div>
          <div className="field">
            <label>Status</label>
            <select className="input select-i" defaultValue="Completed"><option>Completed</option></select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" placeholder="Interpretation notes…"/>
          </div>
        </div>
      )}
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isResult ? "Save Result" : isEdit ? "Update Order" : "Add Order"}</button>
      </div>
    </Modal>
  );
}

function RadiologyModal({ onClose, editData, isReport }) {
  const isEdit = Boolean(editData) && !isReport;
  const [items, setItems] = useState(
    isEdit ? editData.items.map(i => ({ radiology_test_id: i.radiology_test_id || "", test_title: i.test_title, modality: i.test_modality, clinical_indication: i.clinical_indication || "" }))
           : [{ test_title: "", modality: "X-Ray", clinical_indication: "" }]
  );

  const addRow = () => setItems(r => [...r, { test_title: "", modality: "X-Ray", clinical_indication: "" }]);
  const removeRow = (i) => setItems(r => r.filter((_, idx) => idx !== i));

  if (isReport) {
    return (
      <Modal title={`Add Report — ${editData?.test_title}`} onClose={onClose}>
        <div style={{ background:"rgba(16,185,129,.08)", border:"1px solid rgba(16,185,129,.2)", borderRadius:8, padding:"10px 14px", fontSize:12, color:"#10b981", marginBottom:16 }}>
          📋 {editData?.test_title} · {editData?.test_modality} · ₹{editData?.amount}
        </div>
        <div className="modal-grid">
          <div className="field modal-full">
            <label>Radiologist Findings <span style={{ color:"#ef4444" }}>*</span></label>
            <textarea className="input textarea" placeholder="Enter radiologist findings…" style={{ minHeight:100 }} defaultValue={editData?.report || ""}/>
          </div>
          <div className="field">
            <label>Report Date</label>
            <input className="input" type="date" defaultValue="2026-04-01"/>
          </div>
          <div className="field">
            <label>Reported By</label>
            <select className="input select-i">
              <option>Dr. Radha Sharma</option>
              {DOCTORS.map(d => <option key={d.id}>{d.doctor_name}</option>)}
            </select>
          </div>
          <div className="field modal-full">
            <label>Notes</label>
            <textarea className="input textarea" placeholder="Any additional notes…"/>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary">Save Report</button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal title={isEdit ? "Edit Radiology Order" : "New Radiology Order"} onClose={onClose}>
      <div className="modal-grid">
        <div className="field">
          <label>Ordered By</label>
          <select className="input select-i">
            <option>Dr. Priya Mehta</option>
            {DOCTORS.map(d => <option key={d.id}>{d.doctor_name}</option>)}
          </select>
        </div>
        <div className="field">
          <label>Order Date</label>
          <input className="input" type="date" defaultValue={editData?.order_date || "2026-04-01"}/>
        </div>
        <div className="field modal-full">
          <label>Notes</label>
          <input className="input" placeholder="Optional order notes…" defaultValue={editData?.notes || ""}/>
        </div>
      </div>

      <div style={{ fontSize:11, color:"var(--muted)", fontWeight:600, textTransform:"uppercase", letterSpacing:".07em", marginBottom:8, marginTop:4 }}>
        Tests — {items.length} selected
      </div>

      {items.map((item, i) => (
        <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 110px 1fr 28px", gap:6, marginBottom:8, alignItems:"end" }}>
          <div className="field">
            {i === 0 && <label style={{ fontSize:9 }}>Test Name</label>}
            <input className="input" placeholder="e.g. Chest X-Ray PA View" value={item.test_title} onChange={e => setItems(r => r.map((x,idx) => idx===i ? {...x, test_title:e.target.value} : x))}/>
          </div>
          <div className="field">
            {i === 0 && <label style={{ fontSize:9 }}>Modality</label>}
            <select className="input select-i" value={item.modality} onChange={e => setItems(r => r.map((x,idx) => idx===i ? {...x, modality:e.target.value} : x))}>
              {["X-Ray","USG","CT Scan","MRI","PET Scan","Mammography","Echocardiography","Other"].map(m => <option key={m}>{m}</option>)}
            </select>
          </div>
          <div className="field">
            {i === 0 && <label style={{ fontSize:9 }}>Clinical Indication</label>}
            <input className="input" placeholder="Reason for this test…" value={item.clinical_indication} onChange={e => setItems(r => r.map((x,idx) => idx===i ? {...x, clinical_indication:e.target.value} : x))}/>
          </div>
          <button className="icon-btn del" style={{ marginTop: i===0 ? 18 : 0 }} onClick={() => removeRow(i)} disabled={items.length === 1}>✕</button>
        </div>
      ))}

      <button className="btn btn-ghost" style={{ fontSize:11, marginTop:4 }} onClick={addRow}>+ Add Test</button>

      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary">{isEdit ? "Update Order" : "Place Order"}</button>
      </div>
    </Modal>
  );
}

const PROC_TYPES = ["Surgery","Minor Procedure","Endoscopy","Biopsy","Cardiac Procedure","Orthopedic Procedure","Obstetric Procedure","Other"];
const ANESTHESIA_TYPES = ["General","Spinal","Epidural","Local","Sedation","None","Other"];
const PROC_STATUS_OPTIONS = ["Ordered","Scheduled","Pre-Op Preparation","In Progress","Completed","Post-Op Recovery","Cancelled"];

function ProcedureModal({ onClose, proc, onSave }) {
  const isEdit = Boolean(proc);
  const [f, setF] = useState({
    name: proc?.name ?? "", type: proc?.type ?? "Surgery", urgency: proc?.urgency ?? "Elective",
    charges: proc?.charges ?? "", anesthesia: proc?.anesthesia ?? "General",
    surgeon: proc?.surgeon ?? "", anesthesiologist: proc?.anesthesiologist ?? "",
    ot_number: proc?.ot_number ?? "", scheduled_date: proc?.scheduled_date ?? "",
    scheduled_time: proc?.scheduled_time ?? "", notes: proc?.notes ?? "",
  });
  const [errs, setErrs] = useState({});
  const set = (k, v) => { setF(p => ({ ...p, [k]: v })); setErrs(p => ({ ...p, [k]: "" })); };
  const save = () => {
    const e = {};
    if (!f.name.trim()) e.name = "Required";
    if (!f.charges || f.charges <= 0) e.charges = "Required";
    if (Object.keys(e).length) { setErrs(e); return; }
    onSave({ ...f, charges: parseFloat(f.charges), status: proc?.status ?? "Ordered" });
  };
  return (
    <Modal title={isEdit ? `Edit — ${proc.name}` : "Add Procedure Order"} onClose={onClose}>
      <div className="modal-grid">
        <div className="field modal-full"><label>Procedure Name *</label><input className="input" value={f.name} onChange={e => set("name", e.target.value)} placeholder="e.g. Laparoscopic Appendectomy"/>{errs.name && <span style={{fontSize:11,color:"#ef4444"}}>{errs.name}</span>}</div>
        <div className="field"><label>Type</label><select className="input select-i" value={f.type} onChange={e => set("type", e.target.value)}>{PROC_TYPES.map(t => <option key={t}>{t}</option>)}</select></div>
        <div className="field"><label>Urgency</label><select className="input select-i" value={f.urgency} onChange={e => set("urgency", e.target.value)}>{Object.keys(URGENCY).map(u => <option key={u}>{u}</option>)}</select></div>
        <div className="field"><label>Standard Charges (₹) *</label><input className="input" type="number" min="0" value={f.charges} onChange={e => set("charges", e.target.value)}/>{errs.charges && <span style={{fontSize:11,color:"#ef4444"}}>{errs.charges}</span>}</div>
        <div className="field"><label>Anesthesia</label><select className="input select-i" value={f.anesthesia} onChange={e => set("anesthesia", e.target.value)}>{ANESTHESIA_TYPES.map(a => <option key={a}>{a}</option>)}</select></div>
        <div className="field"><label>Surgeon</label><input className="input" value={f.surgeon} onChange={e => set("surgeon", e.target.value)} placeholder="Surgeon name"/></div>
        <div className="field"><label>Anesthesiologist</label><input className="input" value={f.anesthesiologist} onChange={e => set("anesthesiologist", e.target.value)} placeholder="Optional"/></div>
        <div className="field"><label>Assisting Surgeon</label><select className="input select-i" defaultValue={proc?.assisting_surgeon_name || ""}><option value="">None</option><option>Dr. Priya Mehta</option><option>Dr. Ravi Kumar</option><option>Dr. Anjali Singh</option></select></div>
        <div className="field"><label>OT / Room No.</label><input className="input" value={f.ot_number} onChange={e => set("ot_number", e.target.value)} placeholder="e.g. OT-1"/></div>
        <div className="field"><label>Scheduled Date</label><input className="input" type="date" value={f.scheduled_date} onChange={e => set("scheduled_date", e.target.value)}/></div>
        <div className="field"><label>Scheduled Time</label><input className="input" type="time" value={f.scheduled_time} onChange={e => set("scheduled_time", e.target.value)}/></div>
        <div className="field modal-full"><label>Notes</label><textarea className="input textarea" value={f.notes} onChange={e => set("notes", e.target.value)} placeholder="Pre-op notes, consent status…"/></div>
      </div>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save}>{isEdit ? "Update" : "Add"} Procedure</button>
      </div>
    </Modal>
  );
}

function ProcStatusModal({ onClose, proc, onSave }) {
  const [status, setStatus] = useState(proc?.status ?? "Ordered");
  const [sd, setSd] = useState(proc?.scheduled_date ?? "");
  const [st, setSt] = useState(proc?.scheduled_time ?? "");
  const [cancelReason, setCancelReason] = useState(proc?.cancel_reason ?? "");
  const save = () => onSave({ status, scheduled_date: sd, scheduled_time: st, cancel_reason: cancelReason });
  return (
    <Modal title={`Update Status — ${proc?.name}`} onClose={onClose}>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:14 }}>
        {PROC_STATUS_OPTIONS.map(s => {
          const ss = PROC_STATUS[s] || {};
          return (
            <button key={s} onClick={() => setStatus(s)} style={{ padding:"9px", borderRadius:8, cursor:"pointer", fontFamily:"'IBM Plex Sans',sans-serif", fontSize:12, fontWeight:600, transition:"all .15s", background:status===s?ss.color:ss.bg, color:status===s?"#fff":ss.color, border:`1px solid ${ss.color}55` }}>
              {status === s ? "✓ " : ""}{s}
            </button>
          );
        })}
      </div>
      {status === "Scheduled" && (
        <div className="modal-grid" style={{ marginBottom:14 }}>
          <div className="field"><label>Scheduled Date</label><input className="input" type="date" value={sd} onChange={e => setSd(e.target.value)}/></div>
          <div className="field"><label>Scheduled Time</label><input className="input" type="time" value={st} onChange={e => setSt(e.target.value)}/></div>
        </div>
      )}
      {status === "Cancelled" && (
        <div className="field" style={{ marginBottom:14 }}>
          <label>Cancel Reason</label>
          <input className="input" value={cancelReason} onChange={e => setCancelReason(e.target.value)} placeholder="Reason for cancellation…"/>
        </div>
      )}
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save}>Update Status</button>
      </div>
    </Modal>
  );
}

function ProcCompleteModal({ onClose, proc, onSave }) {
  const [f, setF] = useState({
    end_date: proc?.end_date ?? "", end_time: proc?.end_time ?? "",
    duration: proc?.duration ?? "", complications: proc?.complications ?? "None",
    operative_notes: proc?.operative_notes ?? "", complication_details: proc?.complication_details ?? "",
    post_op_instructions: proc?.post_op_instructions ?? "", follow_up_required: proc?.follow_up_required ?? 0,
  });
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const save = () => onSave({ ...f, status: "Completed" });
  return (
    <Modal title={`Complete — ${proc?.name}`} onClose={onClose}>
      <div className="modal-grid">
        <div className="field"><label>End Date</label><input className="input" type="date" value={f.end_date} onChange={e => set("end_date", e.target.value)}/></div>
        <div className="field"><label>End Time</label><input className="input" type="time" value={f.end_time} onChange={e => set("end_time", e.target.value)}/></div>
        <div className="field"><label>Duration (min)</label><input className="input" type="number" min="0" value={f.duration} onChange={e => set("duration", e.target.value)} placeholder="e.g. 90"/></div>
        <div className="field"><label>Complications</label>
          <select className="input select-i" value={f.complications} onChange={e => set("complications", e.target.value)}>
            {["None","Minor","Major"].map(c => <option key={c}>{c}</option>)}
          </select>
        </div>
        {(f.complications === "Minor" || f.complications === "Major") && (
          <div className="field modal-full"><label>Complication Details</label><textarea className="input textarea" value={f.complication_details} onChange={e => set("complication_details", e.target.value)} placeholder="Describe complications…"/></div>
        )}
        <div className="field modal-full"><label>Operative Notes</label><textarea className="input textarea" value={f.operative_notes} onChange={e => set("operative_notes", e.target.value)} placeholder="Intraoperative findings, technique used…" style={{minHeight:80}}/></div>
        <div className="field modal-full"><label>Post-Op Instructions</label><textarea className="input textarea" value={f.post_op_instructions} onChange={e => set("post_op_instructions", e.target.value)} placeholder="e.g. NPO 6 hrs, IV antibiotics…"/></div>
        <div className="field modal-full">
          <label>Follow-up Required</label>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginTop:4 }}>
            <div style={{ width:40,height:22,borderRadius:11,background:f.follow_up_required?"var(--accent)":"var(--bg3)",border:"1px solid",borderColor:f.follow_up_required?"var(--accent)":"var(--border2)",position:"relative",cursor:"pointer",transition:"all .2s" }} onClick={() => set("follow_up_required", f.follow_up_required ? 0 : 1)}>
              <div style={{ position:"absolute",width:16,height:16,borderRadius:"50%",background:"#fff",top:2,left:f.follow_up_required?20:2,transition:"left .2s" }}/>
            </div>
            <span style={{ fontSize:12 }}>{f.follow_up_required ? "Yes" : "No"}</span>
          </div>
        </div>
      </div>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save}>Mark as Completed</button>
      </div>
    </Modal>
  );
}

function TreatmentPanel() {
  const [sub, setSub]     = useState("rx");
  const [modal, setModal] = useState(null);
  const [procs, setProcs] = useState(INIT_PROCEDURE_ORDERS);

  const closeModal = () => setModal(null);

  const handleProcSave = (form) => {
    if (modal?.data) { setProcs(ps => ps.map(p => p.id === modal.data.id ? { ...p, ...form } : p)); }
    else { setProcs(ps => [{ ...form, id: Date.now() }, ...ps]); }
    closeModal();
  };
  const handleProcStatus = (form) => {
    setProcs(ps => ps.map(p => p.id === modal.data.id ? { ...p, ...form } : p));
    closeModal();
  };
  const handleProcComplete = (form) => {
    setProcs(ps => ps.map(p => p.id === modal.data.id ? { ...p, ...form } : p));
    closeModal();
  };
  const handleProcDel = (id) => { setProcs(ps => ps.filter(p => p.id !== id)); };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-accent" style={{ background:"#F59E0B" }}/>
            Treatment & Orders
          </div>
          <button className="btn btn-primary" onClick={() => setModal({ type: sub === "rx" ? "rx" : sub === "lab" ? "lab" : sub === "rad" ? "rad" : "proc" })}>
          + {sub === "rx" ? "Add Prescription" : sub === "lab" ? "Add Lab Order" : sub === "rad" ? "New Radiology Order" : "Add Procedure"}
        </button>
        </div>

        {/* Sub-tabs */}
        <div className="treat-sub-tabs">
          {[
            { id:"rx",   label:`💊 Prescriptions (${PRESCRIPTIONS.length})` },
            { id:"lab",  label:`🧪 Lab Orders (${LAB_ORDERS.length})` },
            { id:"rad",  label:`🩻 Radiology (${RADIOLOGY_ORDERS.length})` },
            { id:"proc", label:`🔪 Procedures (${procs.length})` },
          ].map(t => (
            <button key={t.id} className={`stab ${sub===t.id?"active":""}`} onClick={() => setSub(t.id)}>{t.label}</button>
          ))}
        </div>

        {/* ── Prescriptions ── */}
        {sub === "rx" && (
          PRESCRIPTIONS.length === 0
            ? <div className="empty-state">No prescriptions yet</div>
            : PRESCRIPTIONS.map(rx => (
              <div className="rx-item" key={rx.id}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
                  <Av name={rx.prescribed_by_name} size={28} color={doctorColor(rx.prescribed_by_name)}/>
                  <div>
                    <span style={{ fontSize:12, fontWeight:500 }}>{rx.prescribed_by_name}</span>
                    <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--muted)", marginLeft:8 }}>{rx.prescribed_date} · {rx.prescribed_time}</span>
                  </div>
                  {rx.notes && <span style={{ fontSize:11, color:"var(--muted)", fontStyle:"italic", marginLeft:"auto" }}>{rx.notes}</span>}
                  <button className="icon-btn" onClick={() => setModal({ type:"rx", data:rx })}>✎</button>
                  <button className="icon-btn del">🗑</button>
                </div>
                {rx.medicines.map(m => (
                  <div className="medicine-row" key={m.id}>
                    <span className="med-name">{m.medicine_title}</span>
                    <span className="med-chip">{m.medicine_type}</span>
                    <span className="med-chip" style={{ color:"var(--accent2)" }}>{m.dosage}</span>
                    <span className="med-chip">{m.route}</span>
                    <span className="med-chip">{m.frequency}</span>
                    {m.duration_days && <span className="med-chip">{m.duration_days}d</span>}
                    {m.instructions  && <span style={{ fontSize:11, color:"var(--muted)", flex:1 }}>{m.instructions}</span>}
                    <span style={{ marginLeft:"auto" }}>
                      {m.active === 1
                        ? <span className="active-m" style={{ fontSize:10, padding:"2px 7px", borderRadius:8, fontWeight:600, background:"rgba(16,185,129,.1)", color:"#10b981" }}>Active</span>
                        : <span style={{ fontSize:10, padding:"2px 7px", borderRadius:8, fontWeight:600, background:"rgba(239,68,68,.1)", color:"#ef4444" }} title={m.stop_reason}>Stopped</span>
                      }
                    </span>
                    {m.active === 1 && <button className="icon-btn del" style={{ fontSize:10 }} onClick={() => setModal({ type:"stop", data:m })}>Stop</button>}
                    <button className="icon-btn" onClick={() => setModal({ type:"editMed", data:m })}>✎</button>
                  </div>
                ))}
              </div>
            ))
        )}

        {/* ── Lab Orders ── */}
        {sub === "lab" && <LabOrdersTab/>}

        {/* ── Radiology Orders ── */}
        {sub === "rad" && (
          RADIOLOGY_ORDERS.length === 0
            ? <div className="empty-state">No radiology orders yet</div>
            : RADIOLOGY_ORDERS.map(order => (
              <div key={order.id} style={{ borderBottom:"1px solid var(--border)" }}>
                {/* Order header */}
                <div style={{ display:"flex", alignItems:"center", gap:10, padding:"12px 20px", background:"var(--bg3)" }}>
                  <Av name={order.ordered_by_name} size={28} color={doctorColor(order.ordered_by_name)}/>
                  <div style={{ flex:1 }}>
                    <span style={{ fontSize:12, fontWeight:500 }}>{order.ordered_by_name}</span>
                    <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, color:"var(--muted)", marginLeft:8 }}>{order.order_date} · {order.order_time}</span>
                    <span style={{ fontSize:10, padding:"2px 7px", borderRadius:6, background:"rgba(94,123,255,.12)", color:"var(--accent2)", fontWeight:600, marginLeft:8 }}>{order.source}</span>
                    {order.notes && <span style={{ fontSize:11, color:"var(--muted)", fontStyle:"italic", marginLeft:8 }}>{order.notes}</span>}
                  </div>
                  <span style={{ fontSize:11, color:"var(--muted)" }}>{order.items.length} test{order.items.length !== 1 ? "s" : ""}</span>
                  <span style={{ fontSize:12, fontWeight:600, color:"var(--accent2)", fontFamily:"'IBM Plex Mono',monospace" }}>
                    ₹{order.items.reduce((s, i) => s + i.amount, 0).toLocaleString()}
                  </span>
                  <button className="icon-btn" onClick={() => setModal({ type:"rad", data:order })}>✎</button>
                  <button className="icon-btn del">🗑</button>
                </div>

                {/* Order items */}
                {order.items.map(item => {
                  const sp = STATUS_PILL[item.status] || STATUS_PILL.Pending;
                  const mc = MODALITY_COLOR[item.test_modality] || { bg:"var(--bg3)", color:"var(--muted)" };
                  return (
                    <div key={item.id} style={{ padding:"12px 20px 12px 28px", borderTop:"1px solid var(--border)" }}>
                      <div style={{ display:"flex", alignItems:"flex-start", gap:10 }}>
                        <div style={{ flex:1 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:3 }}>
                            <span style={{ fontSize:13, fontWeight:500 }}>{item.test_title}</span>
                            <span className="mod-chip" style={{ background:mc.bg, color:mc.color }}>{item.test_modality}</span>
                            <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, color:"var(--accent2)" }}>₹{item.amount.toLocaleString()}</span>
                          </div>
                          {item.clinical_indication && (
                            <div style={{ fontSize:11, color:"var(--muted)", marginBottom:4 }}>
                              📌 {item.clinical_indication}
                            </div>
                          )}
                          {item.scheduled_date && item.status !== "Completed" && (
                            <div style={{ fontSize:11, color:"var(--blue)" }}>
                              🗓 Scheduled: {item.scheduled_date} {item.scheduled_time && `· ${item.scheduled_time}`}
                            </div>
                          )}
                          {item.report && (
                            <div className="result-box" style={{ marginTop:6 }}>
                              <div style={{ fontSize:10, color:"var(--dim)", textTransform:"uppercase", letterSpacing:".06em", marginBottom:4 }}>
                                Report · {item.report_date} · {item.reported_by_name}
                              </div>
                              {item.report}
                            </div>
                          )}
                        </div>
                        <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:6, flexShrink:0 }}>
                          <span className="stat-pill" style={{ background:sp.bg, color:sp.color }}>
                            <span style={{ width:5, height:5, borderRadius:"50%", background:"currentColor", display:"inline-block" }}/>
                            {item.status}
                          </span>
                          <div style={{ display:"flex", gap:4 }}>
                            {item.status !== "Completed" && item.status !== "Cancelled" && (
                              <button className="btn btn-ghost btn-sm" style={{ fontSize:10, padding:"3px 8px" }}
                                onClick={() => setModal({ type:"rad", data:item, isReport:true })}>+ Report</button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
        )}

        {/* ── Procedures ── */}
        {sub === "proc" && (
          procs.length === 0
            ? <div className="empty-state">No procedures ordered yet</div>
            : procs.map(proc => {
              const ps = PROC_STATUS[proc.status] || { bg:"var(--bg3)", color:"var(--muted)" };
              const ug = URGENCY[proc.urgency]    || { bg:"var(--bg3)", color:"var(--muted)" };
              return (
                <div key={proc.id} style={{ padding:"14px 20px", borderBottom:"1px solid var(--border)" }}>
                  <div style={{ display:"flex", alignItems:"flex-start", gap:10 }}>
                    <div style={{ fontSize:22, width:38, height:38, borderRadius:10, background:"rgba(94,123,255,.1)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                      {PROC_ICON[proc.type] || "📋"}
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                        <span style={{ fontSize:13, fontWeight:600 }}>{proc.name}</span>
                        <span style={{ fontSize:10, padding:"2px 8px", borderRadius:6, fontWeight:600, background:ug.bg, color:ug.color }}>{proc.urgency}</span>
                        <span style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:11, color:"var(--accent2)", marginLeft:"auto" }}>₹{proc.charges?.toLocaleString()}</span>
                      </div>
                      <div style={{ fontSize:11, color:"var(--muted)", marginBottom:3 }}>
                        {proc.type} · {proc.anesthesia} anesthesia
                        {proc.surgeon && <span> · {proc.surgeon}</span>}
                        {proc.anesthesiologist && <span> · Anest: {proc.anesthesiologist}</span>}
                        {proc.assisting_surgeon_name && <span> · Assist: {proc.assisting_surgeon_name}</span>}
                        {proc.ot_number && <span> · {proc.ot_number}</span>}
                      </div>
                      {proc.scheduled_date && proc.status !== "Completed" && proc.status !== "Cancelled" && (
                        <div style={{ fontSize:11, color:"#3b82f6", marginBottom:3 }}>🗓 Scheduled: {proc.scheduled_date}{proc.scheduled_time && ` · ${proc.scheduled_time}`}</div>
                      )}
                      {proc.status === "Completed" && proc.end_date && (
                        <div style={{ fontSize:11, color:"#10b981", marginBottom:3 }}>✓ Completed: {proc.end_date}{proc.end_time && ` · ${proc.end_time}`}{proc.duration && ` · ${proc.duration} min`}</div>
                      )}
                      {proc.status === "Completed" && proc.complications && proc.complications !== "None" && (
                        <div style={{ fontSize:11, color:"#ef4444", marginBottom:3 }}>⚠ Complications: {proc.complications}{proc.complication_details && ` — ${proc.complication_details}`}</div>
                      )}
                      {proc.status === "Completed" && proc.operative_notes && (
                        <div className="result-box" style={{ marginTop:4 }}><div style={{ fontSize:10, color:"var(--dim)", textTransform:"uppercase", letterSpacing:".06em", marginBottom:3 }}>Operative Notes</div>{proc.operative_notes}</div>
                      )}
                      {proc.status === "Cancelled" && proc.cancel_reason && (
                        <div style={{ fontSize:11, color:"#ef4444", marginBottom:3 }}>✕ Cancelled: {proc.cancel_reason}</div>
                      )}
                      {proc.notes && proc.status !== "Completed" && <div style={{ fontSize:11, color:"var(--muted)", fontStyle:"italic" }}>{proc.notes}</div>}
                    </div>
                    <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:6, flexShrink:0 }}>
                      <span className="stat-pill" style={{ background:ps.bg, color:ps.color }}>
                        <span style={{ width:5,height:5,borderRadius:"50%",background:"currentColor",display:"inline-block" }}/>
                        {proc.status}
                      </span>
                      <div style={{ display:"flex", gap:4 }}>
                        {proc.status !== "Completed" && proc.status !== "Cancelled" && (
                          <>
                            <button className="btn btn-ghost" style={{ fontSize:10, padding:"3px 8px" }} onClick={() => setModal({ type:"procStatus", data:proc })}>Status</button>
                            <button className="btn" style={{ fontSize:10, padding:"3px 8px", background:"rgba(16,185,129,.1)", color:"#10b981", border:"1px solid rgba(16,185,129,.3)" }} onClick={() => setModal({ type:"procComplete", data:proc })}>Complete</button>
                          </>
                        )}
                        <button className="icon-btn" onClick={() => setModal({ type:"proc", data:proc })}>✎</button>
                        <button className="icon-btn del" onClick={() => handleProcDel(proc.id)}>🗑</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
        )}
      </div>

      {/* Modals */}
      {modal?.type === "rx"          && <PrescriptionModal  onClose={closeModal} editData={modal.data}/>}
      {modal?.type === "stop"        && <StopMedicineModal  onClose={closeModal} medicine={modal.data}/>}
      {modal?.type === "lab"         && <LabOrderModal       onClose={closeModal}/>}
      {modal?.type === "rad"         && <RadiologyModal     onClose={closeModal} editData={modal.data} isReport={modal.isReport}/>}
      {modal?.type === "proc"        && <ProcedureModal     onClose={closeModal} proc={modal.data} onSave={handleProcSave}/>}
      {modal?.type === "procStatus"  && <ProcStatusModal    onClose={closeModal} proc={modal.data} onSave={handleProcStatus}/>}
      {modal?.type === "procComplete"&& <ProcCompleteModal  onClose={closeModal} proc={modal.data} onSave={handleProcComplete}/>}
    </>
  );
}

// ── FILES PANEL ───────────────────────────────────────────────────────────────
const FILE_TYPE_ICON  = { pdf:"📄", image:"🖼️", doc:"📝", other:"📎" };
const FILE_TYPE_COLOR = { pdf:"rgba(239,68,68,.12)", image:"rgba(59,130,246,.12)", doc:"rgba(124,58,237,.12)", other:"rgba(107,114,128,.12)" };
const FILE_TYPE_TEXT_COLOR = { pdf:"#ef4444", image:"#3b82f6", doc:"#7c3aed", other:"#9ca3af" };

const REF_LABEL = {
  "radiology_order_item": { label:"Radiology", color:"#3b82f6", bg:"rgba(59,130,246,.12)" },
  "procedure_order":      { label:"Procedure", color:"#ef4444", bg:"rgba(239,68,68,.12)"  },
  "ipd_admission":        { label:"IPD File",  color:"#10b981", bg:"rgba(16,185,129,.12)" },
  "lab_booking":          { label:"Lab",       color:"#f59e0b", bg:"rgba(245,158,11,.12)" },
};

function UploadModal({ onClose, onSave }) {
  const [f, setF] = useState({ file_name:"", file_type:"pdf", reference_type:"", reference_id:"" });
  const [err, setErr] = useState("");
  const set = (k,v) => setF(p=>({...p,[k]:v}));
  const save = () => {
    if (!f.file_name.trim()) { setErr("File name is required"); return; }
    onSave(f);
  };
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">Upload File <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>
        <div className="modal-grid">
          <div className="field mfull">
            <label>File Name *</label>
            <input className="input" value={f.file_name} onChange={e=>{set("file_name",e.target.value);setErr("");}} placeholder="e.g. Chest X-Ray Report"/>
            {err && <span style={{fontSize:11,color:"#ef4444"}}>{err}</span>}
          </div>
          <div className="field mfull">
            <label>Select File</label>
            <input className="input" type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.doc,.docx" style={{paddingTop:6}}/>
          </div>
          <div className="field">
            <label>File Type</label>
            <select className="input select-i" value={f.file_type} onChange={e=>set("file_type",e.target.value)}>
              <option value="pdf">PDF</option>
              <option value="image">Image</option>
              <option value="doc">Document</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="field">
            <label>Link To (Optional)</label>
            <select className="input select-i" value={f.reference_type} onChange={e=>set("reference_type",e.target.value)}>
              <option value="">General File</option>
              <option value="radiology_order_item">Radiology Order</option>
              <option value="procedure_order">Procedure Order</option>
              <option value="ipd_admission">IPD Admission</option>
            </select>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Upload File</button>
        </div>
      </div>
    </div>
  );
}

function DeleteFileModal({ onClose, onConfirm, fileName }) {
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">Delete File <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>
        <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:"10px 12px",fontSize:12,color:"#ef4444",marginBottom:14}}>
          ⚠ This will permanently delete the file from storage.
        </div>
        <div style={{fontSize:13,color:"var(--muted)",marginBottom:16}}>{fileName}</div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn" style={{background:"rgba(239,68,68,.15)",color:"#ef4444",border:"1px solid rgba(239,68,68,.3)"}} onClick={onConfirm}>Yes, Delete</button>
        </div>
      </div>
    </div>
  );
}

function FilesPanel() {
  const [files, setFiles] = useState(PATIENT_FILES);
  const [modal, setModal] = useState(null);
  const [typeF, setTypeF] = useState("all");
  const [toast, setToast] = useState(null);
  const close = () => setModal(null);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(null), 2500); };

  const filtered = typeF === "all" ? files : files.filter(f => f.file_type === typeF);

  const handleUpload = (form) => {
    const newFile = { ...form, id: Date.now(), uploaded_by_name:"Current User", created_at: new Date().toISOString().slice(0,19).replace("T"," "), reference_id: null };
    setFiles(fs => [newFile, ...fs]);
    showToast("File uploaded successfully");
    close();
  };

  const handleDelete = () => {
    setFiles(fs => fs.filter(f => f.id !== modal.data.id));
    showToast("File deleted");
    close();
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-accent" style={{background:"#0891b2"}}/>
            Patient Files
          </div>
          <button className="btn btn-primary" onClick={() => setModal({type:"upload"})}>+ Upload File</button>
        </div>

        {/* Type filter */}
        <div style={{display:"flex",gap:6,padding:"12px 20px",borderBottom:"1px solid var(--border)",flexWrap:"wrap"}}>
          {[
            {k:"all",   label:`All (${files.length})`},
            {k:"pdf",   label:`📄 PDFs (${files.filter(f=>f.file_type==="pdf").length})`},
            {k:"image", label:`🖼️ Images (${files.filter(f=>f.file_type==="image").length})`},
            {k:"doc",   label:`📝 Docs (${files.filter(f=>f.file_type==="doc").length})`},
          ].map(t => (
            <button key={t.k} onClick={() => setTypeF(t.k)} style={{
              padding:"4px 12px", borderRadius:20, border:"1px solid", cursor:"pointer",
              fontFamily:"'IBM Plex Sans',sans-serif", fontSize:11, fontWeight:600, transition:"all .15s",
              background: typeF===t.k ? "var(--accent)" : "var(--bg3)",
              color:      typeF===t.k ? "#fff"          : "var(--muted)",
              borderColor: typeF===t.k ? "var(--accent)" : "var(--border2)",
            }}>{t.label}</button>
          ))}
        </div>

        {/* Files grid */}
        {filtered.length === 0
          ? <div className="empty-state">No files uploaded yet</div>
          : (
            <div className="files-grid">
              {filtered.map(file => {
                const ref = file.reference_type ? REF_LABEL[file.reference_type] : null;
                const tc  = FILE_TYPE_COLOR[file.file_type]      || FILE_TYPE_COLOR.other;
                const tcc = FILE_TYPE_TEXT_COLOR[file.file_type] || FILE_TYPE_TEXT_COLOR.other;
                return (
                  <div key={file.id} className="file-card">
                    <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                      <div className="file-icon" style={{background:tc}}>
                        <span>{FILE_TYPE_ICON[file.file_type] || "📎"}</span>
                      </div>
                      <div style={{flex:1,minWidth:0}}>
                        <div className="file-name" style={{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{file.file_name}</div>
                        <div className="file-meta" style={{marginTop:3}}>{file.uploaded_by_name} · {file.created_at?.slice(0,10)}</div>
                      </div>
                    </div>

                    {ref && (
                      <span className="file-ref" style={{background:ref.bg,color:ref.color}}>
                        <span style={{width:4,height:4,borderRadius:"50%",background:"currentColor",display:"inline-block"}}/>
                        {ref.label}
                      </span>
                    )}

                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:2}}>
                      <span style={{fontSize:10,padding:"2px 7px",borderRadius:5,fontWeight:600,background:tc,color:tcc,textTransform:"uppercase"}}>{file.file_type}</span>
                      <div style={{display:"flex",gap:4}}>
                        <button className="icon-btn" title="View file" onClick={() => window.open("#", "_blank")}>👁</button>
                        <button className="icon-btn del" title="Delete file" onClick={() => setModal({type:"del",data:file})}>🗑</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )
        }
      </div>

      {modal?.type === "upload" && <UploadModal    onClose={close} onSave={handleUpload}/>}
      {modal?.type === "del"    && <DeleteFileModal onClose={close} onConfirm={handleDelete} fileName={modal.data.file_name}/>}
      {toast && <div className="toast"><span style={{color:"var(--green)",fontSize:16}}>✓</span>{toast}</div>}
    </>
  );
}

// ── BILLING PANEL ─────────────────────────────────────────────────────────────
const CHARGE_TYPE_STYLE = {
  "Bed":          { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Consultation": { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "Medicine":     { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Radiology":    { bg:"rgba(8,145,178,.12)",   color:"#0891b2" },
  "Procedure":    { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
  "Lab":          { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Nursing":      { bg:"rgba(236,72,153,.12)",  color:"#ec4899" },
  "Equipment":    { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
  "Other":        { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
};

const PAY_METHOD_STYLE = {
  "Cash":      { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Card":      { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Online":    { bg:"rgba(124,58,237,.12)",  color:"#7c3aed" },
  "Insurance": { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Wallet":    { bg:"rgba(8,145,178,.12)",   color:"#0891b2" },
};

function AddChargeModal({ onClose, onSave }) {
  const TYPES = ["Bed","Consultation","Medicine","Radiology","Procedure","Lab","Nursing","Equipment","Other"];
  const [f, setF] = useState({ charge_type:"Consultation", description:"", quantity:1, unit_price:"", charge_date: new Date().toISOString().slice(0,10), notes:"" });
  const [err, setErr] = useState({});
  const set = (k,v) => { setF(p=>({...p,[k]:v})); setErr(p=>({...p,[k]:""})); };
  const total = (parseFloat(f.unit_price)||0) * (parseFloat(f.quantity)||1);
  const save = () => {
    const e = {};
    if (!f.description.trim()) e.description = "Required";
    if (!f.unit_price || f.unit_price <= 0) e.unit_price = "Required";
    if (Object.keys(e).length) { setErr(e); return; }
    onSave({ ...f, quantity: parseFloat(f.quantity)||1, unit_price: parseFloat(f.unit_price), total_amount: total });
  };
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">Add Charge <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>
        <div className="modal-grid">
          <div className="field">
            <label>Charge Type *</label>
            <select className="input select-i" value={f.charge_type} onChange={e=>set("charge_type",e.target.value)}>
              {TYPES.map(t=><option key={t}>{t}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Charge Date *</label>
            <input className="input" type="date" value={f.charge_date} onChange={e=>set("charge_date",e.target.value)}/>
          </div>
          <div className="field mfull">
            <label>Description *</label>
            <input className="input" value={f.description} onChange={e=>set("description",e.target.value)} placeholder="e.g. Doctor Consultation — 2 Visits"/>
            {err.description && <span style={{fontSize:11,color:"#ef4444"}}>{err.description}</span>}
          </div>
          <div className="field">
            <label>Quantity</label>
            <input className="input" type="number" min="1" value={f.quantity} onChange={e=>set("quantity",e.target.value)}/>
          </div>
          <div className="field">
            <label>Unit Price (₹) *</label>
            <input className="input" type="number" min="0" value={f.unit_price} onChange={e=>set("unit_price",e.target.value)} placeholder="0"/>
            {err.unit_price && <span style={{fontSize:11,color:"#ef4444"}}>{err.unit_price}</span>}
          </div>
          <div className="field mfull">
            <label>Notes</label>
            <input className="input" value={f.notes} onChange={e=>set("notes",e.target.value)} placeholder="Optional notes…"/>
          </div>
        </div>
        {f.unit_price > 0 && (
          <div style={{background:"rgba(94,123,255,.08)",border:"1px solid rgba(94,123,255,.2)",borderRadius:8,padding:"10px 14px",display:"flex",justifyContent:"space-between",marginBottom:14}}>
            <span style={{fontSize:12,color:"var(--muted)"}}>Total Amount</span>
            <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:14,fontWeight:700,color:"var(--accent2)"}}>₹{total.toLocaleString()}</span>
          </div>
        )}
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Add Charge</button>
        </div>
      </div>
    </div>
  );
}

function AddAdvanceModal({ onClose, onSave }) {
  const METHODS = ["Cash","Card","Online","Insurance","Wallet","Cheque","Other"];
  const [f, setF] = useState({ amount:"", payment_method:"Cash", payment_date: new Date().toISOString().slice(0,10), payment_time:"09:00", transaction_ref:"", notes:"" });
  const [err, setErr] = useState("");
  const save = () => {
    if (!f.amount || f.amount <= 0) { setErr("Amount is required"); return; }
    onSave({ ...f, amount: parseFloat(f.amount) });
  };
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">Add Advance Payment <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>
        <div className="modal-grid">
          <div className="field">
            <label>Amount (₹) *</label>
            <input className="input" type="number" min="1" value={f.amount} onChange={e=>{setF(p=>({...p,amount:e.target.value}));setErr("");}} placeholder="0"/>
            {err && <span style={{fontSize:11,color:"#ef4444"}}>{err}</span>}
          </div>
          <div className="field">
            <label>Payment Method *</label>
            <select className="input select-i" value={f.payment_method} onChange={e=>setF(p=>({...p,payment_method:e.target.value}))}>
              {METHODS.map(m=><option key={m}>{m}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Payment Date</label>
            <input className="input" type="date" value={f.payment_date} onChange={e=>setF(p=>({...p,payment_date:e.target.value}))}/>
          </div>
          <div className="field">
            <label>Payment Time</label>
            <input className="input" type="time" value={f.payment_time} onChange={e=>setF(p=>({...p,payment_time:e.target.value}))}/>
          </div>
          <div className="field mfull">
            <label>Transaction Ref</label>
            <input className="input" value={f.transaction_ref} onChange={e=>setF(p=>({...p,transaction_ref:e.target.value}))} placeholder="UPI/Card ref number…"/>
          </div>
          <div className="field mfull">
            <label>Notes</label>
            <input className="input" value={f.notes} onChange={e=>setF(p=>({...p,notes:e.target.value}))} placeholder="Optional notes…"/>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Record Payment</button>
        </div>
      </div>
    </div>
  );
}

function BillingPanel() {
  const [charges,  setCharges]  = useState(INIT_CHARGES);
  const [advances, setAdvances] = useState(INIT_ADVANCES);
  const [section,  setSection]  = useState("charges"); // "charges" | "advances" | "summary"
  const [modal,    setModal]    = useState(null);
  const [toast,    setToast]    = useState(null);
  const [billGenerated, setBillGenerated] = useState(false);

  const showToast = (msg, color="#10b981") => { setToast({msg, color}); setTimeout(()=>setToast(null), 2500); };
  const close = () => setModal(null);

  // Active charges only for totals
  const activeCharges = charges.filter(c => c.active === 1);

  // Summary by type
  const summaryByType = activeCharges.reduce((acc, c) => {
    acc[c.charge_type] = (acc[c.charge_type] || 0) + c.total_amount;
    return acc;
  }, {});

  const grandTotal   = activeCharges.reduce((s, c) => s + c.total_amount, 0);
  const totalAdvance = advances.reduce((s, a) => s + a.amount, 0);
  const netPayable   = Math.max(0, grandTotal - totalAdvance);

  const handleAddCharge = (form) => {
    setCharges(cs => [{ ...form, id: Date.now(), active:1, added_by_name:"Admin User", reference_type:null, reference_id:null }, ...cs]);
    showToast("Charge added");
    close();
  };

  const handleDeleteCharge = (id) => {
    setCharges(cs => cs.map(c => c.id===id ? {...c, active:0} : c));
    showToast("Charge removed", "#f59e0b");
  };

  const handleAddAdvance = (form) => {
    setAdvances(as => [{ ...form, id: Date.now(), collected_by_name:"Admin User" }, ...as]);
    showToast("Advance recorded");
    close();
  };

  const handleDeleteAdvance = (id) => {
    setAdvances(as => as.filter(a => a.id !== id));
    showToast("Advance deleted", "#ef4444");
  };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-accent" style={{background:"#10B981"}}/>
            Billing
          </div>
          <div style={{display:"flex",gap:8}}>
            {section === "charges"  && <button className="btn btn-primary" onClick={()=>setModal("charge")}>+ Add Charge</button>}
            {section === "advances" && <button className="btn btn-primary" onClick={()=>setModal("advance")}>+ Add Advance</button>}
          </div>
        </div>

        {/* Section tabs */}
        <div style={{display:"flex",borderBottom:"1px solid var(--border)",padding:"0 20px"}}>
          {[
            { id:"charges",  label:`💳 Charges (${activeCharges.length})` },
            { id:"advances", label:`💰 Advance Payments (${advances.length})` },
            { id:"summary",  label:"📊 Bill Summary" },
          ].map(s => (
            <button key={s.id} className={`stab ${section===s.id?"active":""}`} onClick={() => setSection(s.id)}>
              {s.label}
            </button>
          ))}
        </div>

        {/* ── Charges ── */}
        {section === "charges" && (
          charges.length === 0
            ? <div className="empty-state">No charges added yet</div>
            : <>
                {charges.map(c => {
                  const cs = CHARGE_TYPE_STYLE[c.charge_type] || CHARGE_TYPE_STYLE["Other"];
                  return (
                    <div key={c.id} className={`charge-row${c.active===0?" inactive":""}`}>
                      <span className="charge-type-badge" style={{background:cs.bg, color:cs.color}}>{c.charge_type}</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:12,fontWeight:500,color:c.active===0?"var(--muted)":"var(--text)"}}>{c.description}</div>
                        <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>{c.charge_date} · {c.added_by_name}</div>
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontSize:11,color:"var(--muted)"}}>{c.quantity} × ₹{c.unit_price?.toLocaleString()}</div>
                        <div style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:13,fontWeight:700,color:c.active===0?"var(--dim)":"var(--accent2)"}}>
                          {c.active===0 ? <s>₹{c.total_amount?.toLocaleString()}</s> : `₹${c.total_amount?.toLocaleString()}`}
                        </div>
                      </div>
                      {c.active===1 && (
                        <button className="icon-btn del" style={{marginLeft:8}} onClick={()=>handleDeleteCharge(c.id)}>🗑</button>
                      )}
                      {c.active===0 && (
                        <span style={{fontSize:10,padding:"2px 7px",borderRadius:6,background:"rgba(239,68,68,.1)",color:"#ef4444",marginLeft:8}}>Removed</span>
                      )}
                    </div>
                  );
                })}
                <div style={{padding:"12px 20px",borderTop:"2px solid var(--border2)",display:"flex",justifyContent:"flex-end",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:12,color:"var(--muted)"}}>Total Charges</span>
                  <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:15,fontWeight:700,color:"var(--accent2)"}}>₹{grandTotal.toLocaleString()}</span>
                </div>
              </>
        )}

        {/* ── Advance Payments ── */}
        {section === "advances" && (
          advances.length === 0
            ? <div className="empty-state">No advance payments recorded</div>
            : <>
                {advances.map(a => {
                  const ps = PAY_METHOD_STYLE[a.payment_method] || {bg:"var(--bg3)",color:"var(--muted)"};
                  return (
                    <div key={a.id} className="advance-row">
                      <span className="pay-method-badge" style={{background:ps.bg,color:ps.color}}>{a.payment_method}</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:12,fontWeight:500}}>{a.payment_date} · {a.payment_time}</div>
                        <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>
                          {a.collected_by_name}
                          {a.transaction_ref && <span style={{marginLeft:8,fontFamily:"'IBM Plex Mono',monospace",fontSize:10}}>#{a.transaction_ref}</span>}
                          {a.notes && <span style={{marginLeft:8,fontStyle:"italic"}}>{a.notes}</span>}
                        </div>
                      </div>
                      <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:14,fontWeight:700,color:"#10b981"}}>₹{a.amount?.toLocaleString()}</span>
                      <button className="icon-btn del" style={{marginLeft:8}} onClick={()=>handleDeleteAdvance(a.id)}>🗑</button>
                    </div>
                  );
                })}
                <div style={{padding:"12px 20px",borderTop:"2px solid var(--border2)",display:"flex",justifyContent:"flex-end",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:12,color:"var(--muted)"}}>Total Advance</span>
                  <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:15,fontWeight:700,color:"#10b981"}}>₹{totalAdvance.toLocaleString()}</span>
                </div>
              </>
        )}

        {/* ── Bill Summary ── */}
        {section === "summary" && (
          <div style={{padding:20}}>
            <div className="billing-grid">

              {/* Charges breakdown */}
              <div className="bill-summary-card">
                <div className="bill-summary-title">Charges by Type</div>
                {Object.entries(summaryByType).map(([type, total]) => {
                  const cs = CHARGE_TYPE_STYLE[type] || CHARGE_TYPE_STYLE["Other"];
                  return (
                    <div className="bill-row" key={type}>
                      <span className="bill-row-label" style={{display:"flex",alignItems:"center",gap:6}}>
                        <span style={{width:8,height:8,borderRadius:"50%",background:cs.color,display:"inline-block"}}/>
                        {type}
                      </span>
                      <span className="bill-row-value" style={{color:cs.color}}>₹{total.toLocaleString()}</span>
                    </div>
                  );
                })}
                <div className="bill-total-row">
                  <span>Total Charges</span>
                  <span style={{fontFamily:"'IBM Plex Mono',monospace",color:"var(--accent2)"}}>₹{grandTotal.toLocaleString()}</span>
                </div>
              </div>

              {/* Payment summary */}
              <div className="bill-summary-card">
                <div className="bill-summary-title">Payment Summary</div>
                <div className="bill-row">
                  <span className="bill-row-label">Total Charges</span>
                  <span className="bill-row-value">₹{grandTotal.toLocaleString()}</span>
                </div>
                <div className="bill-row">
                  <span className="bill-row-label">Total Advance Paid</span>
                  <span className="bill-row-value" style={{color:"#10b981"}}>- ₹{totalAdvance.toLocaleString()}</span>
                </div>
                <div className="bill-total-row">
                  <span>Net Payable</span>
                  <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:18,color:netPayable===0?"#10b981":"var(--accent2)"}}>
                    {netPayable === 0 ? "✓ Paid" : `₹${netPayable.toLocaleString()}`}
                  </span>
                </div>
              </div>
            </div>

            {/* Net payable banner */}
            <div className="bill-net-payable">
              <div>
                <div className="bill-net-label">
                  {netPayable === 0 ? "✓ All Dues Cleared" : "Outstanding Balance"}
                </div>
                <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>
                  {ADMISSION.admission_no} · {ADMISSION.patient_name}
                </div>
              </div>
              <div className="bill-net-value" style={{color: netPayable===0 ? "#10b981" : "var(--accent2)"}}>
                ₹{netPayable.toLocaleString()}
              </div>
            </div>

            {/* Generate bill button */}
            {!billGenerated ? (
              <button
                className="btn btn-primary"
                style={{width:"100%",marginTop:16,padding:"12px",fontSize:13,justifyContent:"center"}}
                onClick={() => { setBillGenerated(true); showToast("Final bill generated successfully"); }}
              >
                🧾 Generate Final Bill
              </button>
            ) : (
              <div style={{background:"rgba(16,185,129,.08)",border:"1px solid rgba(16,185,129,.2)",borderRadius:10,padding:"14px 20px",display:"flex",alignItems:"center",gap:10,marginTop:16}}>
                <span style={{fontSize:20}}>✓</span>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"#10b981"}}>Final bill generated</div>
                  <div style={{fontSize:11,color:"var(--muted)"}}>Invoice created · Net payable ₹{netPayable.toLocaleString()}</div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {modal === "charge"  && <AddChargeModal  onClose={close} onSave={handleAddCharge}/>}
      {modal === "advance" && <AddAdvanceModal onClose={close} onSave={handleAddAdvance}/>}
      {toast && (
        <div className="toast">
          <span style={{color:toast.color,fontSize:16}}>✓</span>
          {toast.msg}
        </div>
      )}
    </>
  );
}

// ── LAB ORDERS TAB ────────────────────────────────────────────────────────────
function LabOrdersTab() {
  const [expanded, setExpanded] = useState({1:true, 2:false, 3:false});
  const [labModal, setLabModal] = useState(null);
  const toggle = id => setExpanded(e => ({...e,[id]:!e[id]}));

  return (
    <>
      {LAB_ORDERS.length === 0
        ? <div className="empty-state">No lab orders yet</div>
        : LAB_ORDERS.map(order => {
          const isOpen  = expanded[order.id];
          const pr      = PRIORITY_STYLE[order.priority] || PRIORITY_STYLE["Routine"];
          const total   = order.items.reduce((s,i) => s + i.amount, 0);
          const pending = order.items.filter(i => i.status !== "Completed" && i.status !== "Cancelled").length;
          return (
            <div className="lab-order-card" key={order.id}>
              <div className="lab-order-head" onClick={() => toggle(order.id)}>
                <Av name={order.ordered_by_name} size={30} color={doctorColor(order.ordered_by_name)}/>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                    <span style={{fontSize:13,fontWeight:600}}>{order.ordered_by_name}</span>
                    <span className="priority-badge" style={{background:pr.bg,color:pr.color}}>{order.priority}</span>
                    {order.notes && <span style={{fontSize:11,color:"var(--muted)",fontStyle:"italic"}}>{order.notes}</span>}
                  </div>
                  <div style={{fontSize:11,color:"var(--muted)",marginTop:2}}>
                    {order.lab_title} · {order.order_date} · {order.order_time}
                    {pending > 0 && <span style={{color:"var(--amber)",marginLeft:8}}>· {pending} pending</span>}
                  </div>
                  {order.clinical_notes && (
                    <div style={{fontSize:11,color:"var(--muted)",marginTop:2,fontStyle:"italic"}}>
                      📌 {order.clinical_notes}
                    </div>
                  )}
                </div>
                <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
                  <span style={{fontSize:11,color:"var(--muted)"}}>{order.items.length} test{order.items.length!==1?"s":""}</span>
                  <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:13,fontWeight:600,color:"var(--accent2)"}}>
                    ₹{total.toLocaleString()}
                  </span>
                  <button className="icon-btn del" onClick={e=>e.stopPropagation()}>🗑</button>
                  <span style={{fontSize:12,color:"var(--muted)",display:"inline-block",transition:"transform .2s",transform:isOpen?"rotate(180deg)":"none"}}>▾</span>
                </div>
              </div>

              {isOpen && order.items.map(item => {
                const ss = LAB_STATUS_STYLE[item.status] || {};
                return (
                  <div className="lab-item-row" key={item.id}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                        <span style={{fontSize:12,fontWeight:500}}>{item.test_title}</span>
                        <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:"var(--accent2)"}}>₹{item.amount.toLocaleString()}</span>
                      </div>
                      {item.sample_collected_at && item.status !== "Completed" && (
                        <div style={{fontSize:10,color:"var(--blue)",marginBottom:3}}>
                          🧪 Sample: {item.sample_collected_at}
                        </div>
                      )}
                      {item.notes && <div style={{fontSize:11,color:"var(--muted)",marginBottom:3}}>📌 {item.notes}</div>}
                      {item.result_text && (
                        <div className="lab-result-box">
                          <div style={{fontSize:9,color:"var(--dim)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:4}}>
                            Result · {item.result_date}
                          </div>
                          {item.result_text}
                        </div>
                      )}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5,flexShrink:0,marginLeft:8}}>
                      <span style={{display:"inline-flex",alignItems:"center",gap:3,padding:"2px 8px",borderRadius:10,fontSize:10,fontWeight:600,background:ss.bg,color:ss.color}}>
                        <span style={{width:4,height:4,borderRadius:"50%",background:"currentColor",display:"inline-block"}}/>
                        {item.status}
                      </span>
                      <div style={{display:"flex",gap:4}}>
                        {item.status !== "Completed" && item.status !== "Cancelled" && <>
                          <button className="btn btn-ghost btn-sm"
                            onClick={()=>setLabModal({type:"status",data:item})}>
                            Status
                          </button>
                          <button className="btn btn-ghost btn-sm"
                            style={{color:"#10b981",borderColor:"rgba(16,185,129,.3)"}}
                            onClick={()=>setLabModal({type:"result",data:item})}>
                            + Result
                          </button>
                        </>}
                        {item.status !== "Completed" && (
                          <button className="icon-btn del">🗑</button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })
      }

      {labModal?.type === "status" && <LabStatusModal onClose={()=>setLabModal(null)} item={labModal.data}/>}
      {labModal?.type === "result" && <LabResultModal onClose={()=>setLabModal(null)} item={labModal.data}/>}
    </>
  );
}

// ── LAB MODALS ────────────────────────────────────────────────────────────────
function LabOrderModal({ onClose }) {
  const TESTS = [
    "Complete Blood Count (CBC)","Liver Function Test (LFT)",
    "Renal Function Test (RFT)","Erythrocyte Sedimentation Rate (ESR)",
    "Blood Sugar Fasting (BSF)","Thyroid Function Test (TFT)",
    "Blood Culture","Urine Routine & Microscopy","Coagulation Profile",
  ];
  const [f, setF] = useState({
    priority:"Routine",
    order_date: new Date().toISOString().slice(0,10),
    order_time:"09:00", clinical_notes:"", notes:"",
  });
  const [selected, setSelected] = useState([]);
  const [open, setOpen]         = useState(false);
  const [err, setErr]           = useState("");

  const toggle = t => { setSelected(p => p.includes(t) ? p.filter(x=>x!==t) : [...p,t]); setErr(""); };

  const save = () => {
    if (selected.length === 0) { setErr("Select at least one test"); return; }
    onClose();
  };

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">
          New Lab Order
          <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div className="modal-grid">
          <div className="field">
            <label>Priority *</label>
            <select className="input select-i" value={f.priority} onChange={e=>setF(p=>({...p,priority:e.target.value}))}>
              <option>Routine</option><option>Urgent</option><option>STAT</option>
            </select>
          </div>
          <div className="field">
            <label>Order Date</label>
            <input className="input" type="date" value={f.order_date} onChange={e=>setF(p=>({...p,order_date:e.target.value}))}/>
          </div>
          <div className="field mfull">
            <label>Clinical Notes</label>
            <input className="input" value={f.clinical_notes} onChange={e=>setF(p=>({...p,clinical_notes:e.target.value}))} placeholder="Reason for ordering..."/>
          </div>

          {/* ── Multi-select dropdown ── */}
          <div className="field mfull" style={{position:"relative"}}>
            <label>
              Select Tests *
              {err && <span style={{color:"#ef4444",fontWeight:400,textTransform:"none",fontSize:11}}> — {err}</span>}
            </label>

            {/* Click-away layer */}
            {open && <div style={{position:"fixed",inset:0,zIndex:9}} onClick={()=>setOpen(false)}/>}

            {/* Trigger */}
            <div
              className="input"
              style={{
                cursor:"pointer", display:"flex", alignItems:"center",
                justifyContent:"space-between", userSelect:"none", marginTop:2,
                borderColor: open ? "var(--accent)" : err ? "#ef4444" : undefined,
              }}
              onClick={()=>setOpen(o=>!o)}
            >
              <span style={{fontSize:13, color: selected.length ? "var(--text)" : "var(--muted)"}}>
                {selected.length === 0
                  ? "Select tests…"
                  : `${selected.length} test${selected.length > 1 ? "s" : ""} selected`}
              </span>
              <span style={{
                fontSize:11, color:"var(--muted)",
                display:"inline-block", transition:"transform .2s",
                transform: open ? "rotate(180deg)" : "none",
              }}>▾</span>
            </div>

            {/* Dropdown panel */}
            {open && (
              <div style={{
                position:"absolute", top:"calc(100% + 4px)", left:0, right:0, zIndex:10,
                background:"var(--bg2)", border:"1px solid var(--border2)",
                borderRadius:10, overflow:"hidden",
                boxShadow:"0 8px 28px rgba(0,0,0,.5)",
              }}>
                {TESTS.map(t => {
                  const checked = selected.includes(t);
                  return (
                    <div
                      key={t}
                      onClick={()=>toggle(t)}
                      style={{
                        display:"flex", alignItems:"center", gap:10,
                        padding:"9px 14px", cursor:"pointer",
                        background: checked ? "rgba(94,123,255,.08)" : "transparent",
                        transition:"background .1s",
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = checked ? "rgba(94,123,255,.13)" : "var(--bg3)"}
                      onMouseLeave={e => e.currentTarget.style.background = checked ? "rgba(94,123,255,.08)" : "transparent"}
                    >
                      {/* Checkbox */}
                      <div style={{
                        width:16, height:16, borderRadius:4, flexShrink:0,
                        border:`2px solid ${checked ? "var(--accent)" : "var(--border2)"}`,
                        background: checked ? "var(--accent)" : "transparent",
                        display:"flex", alignItems:"center", justifyContent:"center",
                        transition:"all .15s",
                      }}>
                        {checked && <span style={{color:"#fff", fontSize:9, fontWeight:700, lineHeight:1}}>✓</span>}
                      </div>
                      <span style={{
                        fontSize:13,
                        color:   checked ? "var(--text)"  : "var(--muted)",
                        fontWeight: checked ? 500 : 400,
                      }}>{t}</span>
                    </div>
                  );
                })}
                {/* Footer */}
                <div style={{
                  padding:"7px 14px", borderTop:"1px solid var(--border)",
                  display:"flex", justifyContent:"space-between", alignItems:"center",
                  background:"var(--bg3)",
                }}>
                  <span style={{fontSize:11, color:"var(--muted)"}}>
                    {selected.length === 0 ? "None selected" : `${selected.length} of ${TESTS.length} selected`}
                  </span>
                  {selected.length > 0 && (
                    <button
                      onClick={e=>{e.stopPropagation(); setSelected([]);}}
                      style={{
                        fontSize:11, color:"#ef4444", background:"none",
                        border:"none", cursor:"pointer",
                        fontFamily:"'IBM Plex Sans',sans-serif", padding:0,
                      }}
                    >Clear all</button>
                  )}
                </div>
              </div>
            )}

            {/* Selected chips */}
            {selected.length > 0 && (
              <div style={{display:"flex", flexWrap:"wrap", gap:6, marginTop:8}}>
                {selected.map(t => (
                  <span key={t} style={{
                    display:"inline-flex", alignItems:"center", gap:4,
                    padding:"3px 6px 3px 10px", borderRadius:20,
                    background:"rgba(94,123,255,.14)",
                    border:"1px solid rgba(94,123,255,.3)",
                    fontSize:11, color:"var(--accent2)", fontWeight:500,
                  }}>
                    {t}
                    <button
                      onClick={()=>toggle(t)}
                      style={{
                        background:"none", border:"none", color:"var(--accent2)",
                        cursor:"pointer", fontSize:14, lineHeight:1,
                        padding:"0 2px", display:"flex", alignItems:"center",
                        opacity:.7,
                      }}
                    >×</button>
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="field mfull">
            <label>Notes</label>
            <input className="input" value={f.notes} onChange={e=>setF(p=>({...p,notes:e.target.value}))} placeholder="Optional notes..."/>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Create Order</button>
        </div>
      </div>
    </div>
  );
}

function LabStatusModal({ onClose, item }) {
  const STATUSES = ["Ordered","Sample Collected","Processing","Completed","Cancelled"];
  const [sel, setSel] = useState(item?.status || "Ordered");
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">
          Update Status — {item?.test_title}
          <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
          {STATUSES.map(s => {
            const ss = LAB_STATUS_STYLE[s] || {};
            return (
              <button key={s} onClick={()=>setSel(s)} style={{
                padding:"9px", borderRadius:8, cursor:"pointer",
                fontFamily:"'IBM Plex Sans',sans-serif", fontSize:12, fontWeight:600,
                transition:"all .15s",
                background: sel===s ? ss.color : ss.bg,
                color:      sel===s ? "#fff"   : ss.color,
                border:`1px solid ${ss.color}55`,
              }}>
                {sel===s?"✓ ":""}{s}
              </button>
            );
          })}
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={onClose}>Update Status</button>
        </div>
      </div>
    </div>
  );
}

function LabResultModal({ onClose, item }) {
  const [f, setF] = useState({ result_text:"", result_date: new Date().toISOString().slice(0,10), notes:"" });
  const [err, setErr] = useState("");
  const save = () => {
    if (!f.result_text.trim()) { setErr("Result is required"); return; }
    onClose();
  };
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-title">
          Add Result — {item?.test_title}
          <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
        <div style={{background:"rgba(16,185,129,.08)",border:"1px solid rgba(16,185,129,.2)",borderRadius:8,padding:"10px 12px",fontSize:12,marginBottom:14}}>
          <span style={{color:"#10b981",fontWeight:600}}>{item?.test_title}</span>
          <span style={{color:"var(--muted)",marginLeft:8}}>₹{item?.amount?.toLocaleString()}</span>
        </div>
        <div className="modal-grid">
          <div className="field mfull">
            <label>Result *</label>
            <textarea className="input textarea"
              value={f.result_text}
              onChange={e=>{setF(p=>({...p,result_text:e.target.value}));setErr("");}}
              placeholder={"e.g. WBC: 11.2 K/µL (High)\nRBC: 4.5 M/µL (Normal)"}
              style={{minHeight:100}}/>
            {err && <span style={{fontSize:11,color:"#ef4444"}}>{err}</span>}
          </div>
          <div className="field">
            <label>Result Date</label>
            <input className="input" type="date" value={f.result_date} onChange={e=>setF(p=>({...p,result_date:e.target.value}))}/>
          </div>
          <div className="field">
            <label>Notes</label>
            <input className="input" value={f.notes} onChange={e=>setF(p=>({...p,notes:e.target.value}))} placeholder="Optional notes..."/>
          </div>
        </div>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save}>Save Result</button>
        </div>
      </div>
    </div>
  );
}

// ── DISCHARGE ─────────────────────────────────────────────────────────────────
function DischargeSummaryModal({ onClose, existing, onSave }) {
  const isEdit = Boolean(existing?.final_diagnosis);
  const CONDITIONS = ["Recovered","Improved","Stable","Referred","Against Medical Advice","Death"];

  const [f, setF] = useState({
    final_diagnosis:           existing?.final_diagnosis           || "",
    discharge_condition:       existing?.discharge_condition       || "Improved",
    history_and_presentation:  existing?.history_and_presentation  || "",
    investigations_summary:    existing?.investigations_summary    || "",
    treatment_given:           existing?.treatment_given           || "",
    summary:                   existing?.summary                   || "",
    discharge_medicines:       existing?.discharge_medicines       || "",
    dietary_advice:            existing?.dietary_advice            || "",
    activity_restrictions:     existing?.activity_restrictions     || "",
    wound_care:                existing?.wound_care                || "",
    follow_up_required:        existing?.follow_up_required        || 0,
    follow_up_date:            existing?.follow_up_date            || "",
    follow_up_notes:           existing?.follow_up_notes           || "",
    notes:                     existing?.notes                     || "",
  });
  const [err, setErr] = useState("");
  const [saving, setSaving] = useState(false);

  const set = (k,v) => setF(p=>({...p,[k]:v}));

  const save = () => {
    if (!f.final_diagnosis.trim()) { setErr("Final diagnosis is required"); return; }
    setSaving(true);
    setTimeout(() => { onSave(f); setSaving(false); }, 500);
  };

  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal-box" style={{maxWidth:680}} onClick={e=>e.stopPropagation()}>
        <div className="modal-title">
          {isEdit ? "Edit Discharge Summary" : "Create Discharge Summary"}
          <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>

        <div className="modal-grid">
          {/* Clinical */}
          <div className="field mfull">
            <label>Final Diagnosis *</label>
            <input className="input" value={f.final_diagnosis}
              onChange={e=>{set("final_diagnosis",e.target.value);setErr("");}}
              placeholder="e.g. Acute febrile illness with mild hepatitis — resolved"/>
            {err && <span style={{fontSize:11,color:"#ef4444"}}>{err}</span>}
          </div>
          <div className="field">
            <label>Discharge Condition *</label>
            <select className="input select-i" value={f.discharge_condition}
              onChange={e=>set("discharge_condition",e.target.value)}>
              {CONDITIONS.map(c=><option key={c}>{c}</option>)}
            </select>
          </div>
          <div className="field">
            <label>Follow-up Required</label>
            <select className="input select-i" value={f.follow_up_required}
              onChange={e=>set("follow_up_required",parseInt(e.target.value))}>
              <option value={0}>No</option>
              <option value={1}>Yes</option>
            </select>
          </div>
          {f.follow_up_required === 1 && <>
            <div className="field">
              <label>Follow-up Date</label>
              <input className="input" type="date" value={f.follow_up_date}
                onChange={e=>set("follow_up_date",e.target.value)}/>
            </div>
            <div className="field">
              <label>Follow-up Notes</label>
              <input className="input" value={f.follow_up_notes}
                onChange={e=>set("follow_up_notes",e.target.value)}
                placeholder="e.g. Review LFTs — OPD Dr. Mehta"/>
            </div>
          </>}

          {/* Clinical sections */}
          <div className="field mfull">
            <label>History &amp; Presentation</label>
            <textarea className="input textarea" value={f.history_and_presentation}
              onChange={e=>set("history_and_presentation",e.target.value)}
              placeholder="Brief history on admission..." style={{minHeight:70}}/>
          </div>
          <div className="field mfull">
            <label>Investigations Summary</label>
            <textarea className="input textarea" value={f.investigations_summary}
              onChange={e=>set("investigations_summary",e.target.value)}
              placeholder="Key lab and radiology findings..." style={{minHeight:70}}/>
          </div>
          <div className="field mfull">
            <label>Treatment Given</label>
            <textarea className="input textarea" value={f.treatment_given}
              onChange={e=>set("treatment_given",e.target.value)}
              placeholder="Procedures and medicines during stay..." style={{minHeight:70}}/>
          </div>
          <div className="field mfull">
            <label>Discharge Summary</label>
            <textarea className="input textarea" value={f.summary}
              onChange={e=>set("summary",e.target.value)}
              placeholder="Overall summary and clinical course..." style={{minHeight:80}}/>
          </div>

          {/* Instructions */}
          <div className="field mfull">
            <label>Discharge Medicines</label>
            <textarea className="input textarea" value={f.discharge_medicines}
              onChange={e=>set("discharge_medicines",e.target.value)}
              placeholder={"1. Tab Paracetamol 500mg — TDS x 3 days\n2. Tab Pantoprazole 40mg — OD x 7 days"}
              style={{minHeight:80}}/>
          </div>
          <div className="field">
            <label>Dietary Advice</label>
            <textarea className="input textarea" value={f.dietary_advice}
              onChange={e=>set("dietary_advice",e.target.value)}
              placeholder="Food and diet recommendations..." style={{minHeight:60}}/>
          </div>
          <div className="field">
            <label>Activity Restrictions</label>
            <textarea className="input textarea" value={f.activity_restrictions}
              onChange={e=>set("activity_restrictions",e.target.value)}
              placeholder="Rest, no lifting etc..." style={{minHeight:60}}/>
          </div>
          <div className="field mfull">
            <label>Wound Care</label>
            <input className="input" value={f.wound_care}
              onChange={e=>set("wound_care",e.target.value)}
              placeholder="Dressing and wound management instructions (if applicable)"/>
          </div>
          <div className="field mfull">
            <label>Notes</label>
            <input className="input" value={f.notes}
              onChange={e=>set("notes",e.target.value)}
              placeholder="Optional internal notes..."/>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>
            {saving ? "Saving..." : isEdit ? "Update Summary" : "Create Summary"}
          </button>
        </div>
      </div>
    </div>
  );
}

function DischargePanel() {
  const [summary, setSummary] = useState(null);
  const [modal, setModal]     = useState(null);
  const [toast, setToast]     = useState(null);

  const showToast = (msg, color="#10b981") => {
    setToast({msg, color});
    setTimeout(() => setToast(null), 2500);
  };

  const handleSave = (form) => {
    setSummary({ ...form, id: Date.now(), prepared_by_name:"Dr. Ravi Kumar", signed_by_name:null, signed_at:null });
    showToast(summary ? "Discharge summary updated" : "Discharge summary created");
    setModal(null);
  };

  const handleSign = () => {
    setSummary(s => ({ ...s, signed_by_name:"Dr. Priya Mehta", signed_at: new Date().toLocaleString() }));
    showToast("Discharge summary signed and locked");
    setModal(null);
  };

  const isSigned   = Boolean(summary?.signed_at);
  const condition  = summary ? (CONDITION_STYLE[summary.discharge_condition] || {}) : {};

  return (
    <>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <span className="card-accent" style={{background:"#7C3AED"}}/>
            Discharge Summary
          </div>
          {!isSigned && (
            <div style={{display:"flex",gap:8}}>
              {summary && (
                <button className="btn btn-ghost"
                  onClick={() => setModal("sign")}
                  style={{color:"#10b981",borderColor:"rgba(16,185,129,.3)"}}>
                  ✓ Sign Summary
                </button>
              )}
              <button className="btn btn-primary"
                onClick={() => setModal("form")}>
                {summary ? "✎ Edit" : "+ Create Summary"}
              </button>
            </div>
          )}
        </div>

        {/* Not created yet */}
        {!summary && (
          <div style={{padding:"40px 20px",textAlign:"center"}}>
            <div style={{fontSize:32,marginBottom:12}}>📋</div>
            <div style={{fontSize:14,fontWeight:500,color:"var(--text)",marginBottom:6}}>
              No discharge summary yet
            </div>
            <div style={{fontSize:12,color:"var(--muted)",marginBottom:20}}>
              Create the discharge summary before discharging the patient
            </div>
            <button className="btn btn-primary" onClick={() => setModal("form")}>
              + Create Discharge Summary
            </button>
          </div>
        )}

        {/* Summary exists */}
        {summary && (
          <div style={{padding:16}}>

            {/* Signed / Unsigned banner */}
            {isSigned ? (
              <div className="signed-banner">
                <span style={{fontSize:20}}>✓</span>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"#10b981"}}>Summary signed and locked</div>
                  <div style={{fontSize:11,color:"var(--muted)"}}>
                    Signed by {summary.signed_by_name} · {summary.signed_at}
                  </div>
                </div>
              </div>
            ) : (
              <div className="unsigned-banner">
                <span style={{fontSize:20}}>⚠</span>
                <div>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--amber)"}}>Pending signature</div>
                  <div style={{fontSize:11,color:"var(--muted)"}}>
                    Summary not yet signed. Prepared by {summary.prepared_by_name}.
                  </div>
                </div>
              </div>
            )}

            {/* Condition + follow-up header */}
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16,flexWrap:"wrap"}}>
              <span className="condition-badge"
                style={{background:condition.bg, color:condition.color}}>
                {summary.discharge_condition}
              </span>
              {summary.follow_up_required === 1 && (
                <span style={{fontSize:11,color:"var(--amber)",background:"rgba(245,158,11,.1)",
                  border:"1px solid rgba(245,158,11,.2)",borderRadius:6,padding:"2px 10px",fontWeight:600}}>
                  📅 Follow-up: {summary.follow_up_date || "Date TBD"}
                </span>
              )}
            </div>

            {/* Sections */}
            {[
              { icon:"🩺", label:"Final Diagnosis",           key:"final_diagnosis" },
              { icon:"📖", label:"History & Presentation",    key:"history_and_presentation" },
              { icon:"🔬", label:"Investigations Summary",    key:"investigations_summary" },
              { icon:"💊", label:"Treatment Given",           key:"treatment_given" },
              { icon:"📄", label:"Discharge Summary",         key:"summary" },
              { icon:"💊", label:"Discharge Medicines",       key:"discharge_medicines" },
              { icon:"🥗", label:"Dietary Advice",            key:"dietary_advice" },
              { icon:"🚶", label:"Activity Restrictions",     key:"activity_restrictions" },
              { icon:"🩹", label:"Wound Care",                key:"wound_care" },
              { icon:"📅", label:"Follow-up Instructions",   key:"follow_up_notes" },
            ].filter(s => summary[s.key]).map(s => (
              <div className="discharge-section" key={s.key}>
                <div className="discharge-section-head">
                  <span style={{fontSize:14}}>{s.icon}</span>
                  <span className="discharge-section-label">{s.label}</span>
                </div>
                <div className="discharge-section-body">
                  <div className="discharge-field-value">{summary[s.key]}</div>
                </div>
              </div>
            ))}

            {summary.notes && (
              <div style={{fontSize:11,color:"var(--muted)",fontStyle:"italic",marginTop:8}}>
                📌 {summary.notes}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Sign confirm */}
      {modal === "sign" && (
        <div className="modal-bg" onClick={() => setModal(null)}>
          <div className="modal-box" style={{maxWidth:420}} onClick={e=>e.stopPropagation()}>
            <div className="modal-title">
              Sign Discharge Summary
              <button onClick={() => setModal(null)} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
            </div>
            <div style={{background:"rgba(16,185,129,.08)",border:"1px solid rgba(16,185,129,.2)",borderRadius:8,padding:"12px 14px",marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:500,color:"#10b981",marginBottom:4}}>
                ✓ Confirm sign-off
              </div>
              <div style={{fontSize:12,color:"var(--muted)"}}>
                Once signed this summary cannot be edited. This action confirms the summary is clinically accurate and approved for discharge.
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
              <button className="btn" style={{background:"rgba(16,185,129,.15)",color:"#10b981",border:"1px solid rgba(16,185,129,.3)"}}
                onClick={handleSign}>
                ✓ Sign and Lock
              </button>
            </div>
          </div>
        </div>
      )}

      {modal === "form" && (
        <DischargeSummaryModal
          onClose={() => setModal(null)}
          existing={summary}
          onSave={handleSave}
        />
      )}

      {toast && (
        <div className="toast">
          <span style={{color:toast.color,fontSize:16}}>✓</span>
          {toast.msg}
        </div>
      )}
    </>
  );
}

// ── MAIN PAGE ─────────────────────────────────────────────────────────────────
const TABS = [
  { id:"vitals",    label:"Vitals",        icon:"🩺" },
  { id:"rounds",    label:"Doctor Rounds", icon:"👨‍⚕️" },
  { id:"nursing",   label:"Nursing Notes", icon:"📋" },
  { id:"diet",      label:"Diet Plan",     icon:"🍽️" },
  { id:"treatment", label:"Treatment",     icon:"💊" },
  { id:"change",    label:"Dr. Change",    icon:"🔄" },
  { id:"transfer",  label:"Transfer",      icon:"🚶" },
  { id:"files",     label:"Files",         icon:"📁" },
  { id:"billing",   label:"Billing",       icon:"💰" },
  { id:"discharge", label:"Discharge",     icon:"📋" },
];

const today = new Date("2026-05-01");
const admitted = new Date(ADMISSION.admission_date);
const daysAdmitted = Math.floor((today - admitted) / 86400000);
const daysLeft = Math.max(0, Math.floor((new Date(ADMISSION.expected_discharge_date) - today) / 86400000));

export default function AdmissionDetail() {
  const [activeTab, setActiveTab] = useState("treatment");

  return (
    <>
      <style>{css}</style>
      <div className="page">
        <button className="back-btn">← Back to Admissions</button>

        {/* Header card */}
        <div className="header-card">
          <div>
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:10 }}>
              <Av name={ADMISSION.patient_name} size={52} color="#5E7BFF"/>
              <div>
                <div className="patient-name">{ADMISSION.patient_name}</div>
                <div className="patient-phone">{ADMISSION.patient_phone}</div>
              </div>
              <span className={`status-badge status-${ADMISSION.status.toLowerCase()}`}>
                <span style={{ width:6,height:6,borderRadius:"50%",background:"currentColor",display:"inline-block" }}/>
                {ADMISSION.status}
              </span>
              <span style={{ fontSize:11, padding:"3px 10px", borderRadius:12, background:"rgba(245,158,11,.12)", color:"#F59E0B", fontWeight:600 }}>
                {ADMISSION.admission_type}
              </span>
            </div>

            <div className="admission-no">{ADMISSION.admission_no}</div>

            {/* Doctors row */}
            <div className="doctors-row">
              {DOCTORS.map(d => (
                <div className="doctor-chip" key={d.id}>
                  <div className="doc-av" style={{ background:doctorColor(d.doctor_name) }}>{initials(d.doctor_name)}</div>
                  <div>
                    <div className="doc-name">{d.doctor_name}</div>
                    <div className="doc-role">{d.role} · {d.specialization}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="meta-grid">
              {[
                ["Ward",       ADMISSION.ward_title],
                ["Bed",        ADMISSION.bed_number],
                ["Admitted",   fmtDate(ADMISSION.admission_date)],
                ["Expected D/C", fmtDate(ADMISSION.expected_discharge_date)],
                ["Clinic",     ADMISSION.clinic_title],
                ["Source",     ADMISSION.source],
                ["Days In",    `${daysAdmitted} days`],
                ["Days Left",  `${daysLeft} days`],
              ].map(([l,v]) => (
                <div className="meta-item" key={l}>
                  <div className="meta-label">{l}</div>
                  <div className="meta-value">{v}</div>
                </div>
              ))}
            </div>

            {ADMISSION.diagnosis && (
              <div style={{ marginTop:12, background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:10, padding:"10px 14px" }}>
                <div style={{ fontSize:10, color:"var(--muted)", textTransform:"uppercase", letterSpacing:".07em", marginBottom:3 }}>Diagnosis</div>
                <div style={{ fontSize:13, color:"var(--text)", lineHeight:1.6 }}>{ADMISSION.diagnosis}</div>
              </div>
            )}
          </div>

          {/* Days left box */}
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div className="days-box">
              <div className="days-num">{daysLeft}</div>
              <div className="days-label">days left</div>
            </div>
            <div style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:12, padding:"12px 16px", textAlign:"center" }}>
              <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:22, fontWeight:500, color:"var(--accent2)" }}>{daysAdmitted}</div>
              <div style={{ fontSize:11, color:"var(--muted)", marginTop:2 }}>days admitted</div>
            </div>
            <button className="btn btn-primary" style={{ justifyContent:"center" }}>Discharge</button>
            <button className="btn btn-ghost"   style={{ justifyContent:"center" }}>Transfer</button>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs">
          {TABS.map(t => (
            <button key={t.id} className={`tab ${activeTab===t.id?"active":""}`} onClick={() => setActiveTab(t.id)}>
              <span>{t.icon}</span> {t.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        {activeTab === "vitals"    && <VitalsPanel/>}
        {activeTab === "rounds"    && <RoundsPanel/>}
        {activeTab === "nursing"   && <NursingPanel/>}
        {activeTab === "diet"      && <DietPanel/>}
        {activeTab === "treatment" && <TreatmentPanel/>}
        {activeTab === "change"    && <DoctorChangePanel/>}
        {activeTab === "transfer"  && <TransferPanel/>}
        {activeTab === "files"     && <FilesPanel/>}
        {activeTab === "billing"   && <BillingPanel/>}
        {activeTab === "discharge" && <DischargePanel/>}
      </div>
    </>
  );
}
